import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import 'react-dom';
import { _ as _slicedToArray, k as _defineProperty, a as _objectSpread2, g as _inherits, h as _createSuper, j as _classCallCheck, l as _assertThisInitialized, i as _createClass, d as _taggedTemplateLiteral } from './_rollupPluginBabelHelpers-b9ad31fa-7ae21c08.js';
import styled, { withTheme } from 'styled-components';
import { s as styleInject, T as Tooltip } from './withTooltip-92e0dfed.js';
import '@styled-system/space';
import '@styled-system/color';
import '@styled-system/border';
import '@styled-system/variant';
import '@styled-system/typography';
import { I as Icon, f as AngleDownIcon } from './index-28a062d6-3659b895.js';
import './index-155df85b-a520c7f0.js';
import './generic-7099c3ed-1383f6f8.js';
import { B as Button } from './button-fb2021fd.js';
import { T as Text } from './text-5e5c8ea1.js';
import '@styled-system/layout';
import '@styled-system/flexbox';
import '@styled-system/position';
import '@styled-system/shadow';
import { B as Box } from './box-e581bc98.js';
import { c as cc, T as Text$1, a as Label, b as TextInput } from './index-5dfda37f-a2c0763c.js';
import { u as useEnterKey } from './useEnterKey-1841e752-4d3d6e9b.js';
import { c as createCommonjsModule, a as commonjsGlobal } from './fuse-b0dfead8-7a3d565d.js';
import { C as Checkbox, D as Dropdown } from './dropdown-75073a0f.js';
import { T as Toggle } from './toggle-6e04c39b.js';
import { I as IconWrapper, g as getObjectValue } from './IconWrapper-f69d60c7-8a74d4d9.js';
import '@styled-system/grid';
import '@styled-system/background';
import './index.esm-f8e9e79f-5619e21b.js';
import { A as ArrowDownIcon } from './ArrowDownIcon-163348d2.js';

var dayjs_min = createCommonjsModule(function (module, exports) {
!function(t,e){module.exports=e();}(commonjsGlobal,(function(){var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return "["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return !r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return (e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return -t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return +(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return {M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else {var a=e.name;D[a]=e,i=a;}return !r&&i&&(g=i),i||!r&&g},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=v;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t);}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init();},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds();},m.$utils=function(){return O},m.isValid=function(){return !(this.$d.toString()===l)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),l=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(h){case c:return r?l(1,0):l(31,11);case f:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),l=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d;}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,l=this;r=Number(r);var $=O.p(h),y=function(t){var e=w(l);return O.w(e.date(e.date()+Math.round(t*r)),l)};if($===f)return this.set(f,this.$M+r);if($===c)return this.set(c,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},$={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||$[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,v=this-M,g=O.m(this,M);return g=($={},$[c]=g/12,$[f]=g,$[h]=g/3,$[o]=(v-m)/6048e5,$[a]=(v-m)/864e5,$[u]=v/n,$[s]=v/e,$[i]=v/t,$)[y]||v,l?g:O.a(g)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),T=_.prototype;return w.prototype=T,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){T[t[1]]=function(e){return this.$g(e,t[0],t[1])};})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[g],w.Ls=D,w.p={},w}));
});

var ArrowLefttIconV4 = function ArrowLefttIconV4(props) {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 12H5M5 12L12 19M5 12L12 5",
    stroke: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep),
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
ArrowLefttIconV4.propTypes = {
  iconColor: PropTypes.string
};
ArrowLefttIconV4.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ArrowLefttIconV4",
  "props": {
    "iconColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
var ArrowLeftIconV4 = withTheme(ArrowLefttIconV4);

var ArrowRightIconV4 = function ArrowRightIconV4(props) {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 12H19M19 12L12 5M19 12L12 19",
    stroke: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep),
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
ArrowRightIconV4.propTypes = {
  iconColor: PropTypes.string
};
ArrowRightIconV4.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ArrowRightIconV4",
  "props": {
    "iconColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
var ArrowRightIconV4$1 = withTheme(ArrowRightIconV4);

var customParseFormat = createCommonjsModule(function (module, exports) {
!function(e,t){module.exports=t();}(commonjsGlobal,(function(){var e={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},t=/(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g,n=/\d\d/,r=/\d\d?/,i=/\d*[^-_:/,()\s\d]+/,o={},s=function(e){return (e=+e)+(e>68?1900:2e3)};var a=function(e){return function(t){this[e]=+t;}},f=[/[+-]\d\d:?(\d\d)?|Z/,function(e){(this.zone||(this.zone={})).offset=function(e){if(!e)return 0;if("Z"===e)return 0;var t=e.match(/([+-]|\d\d)/g),n=60*t[1]+(+t[2]||0);return 0===n?0:"+"===t[0]?-n:n}(e);}],h=function(e){var t=o[e];return t&&(t.indexOf?t:t.s.concat(t.f))},u=function(e,t){var n,r=o.meridiem;if(r){for(var i=1;i<=24;i+=1)if(e.indexOf(r(i,0,t))>-1){n=i>12;break}}else n=e===(t?"pm":"PM");return n},d={A:[i,function(e){this.afternoon=u(e,!1);}],a:[i,function(e){this.afternoon=u(e,!0);}],S:[/\d/,function(e){this.milliseconds=100*+e;}],SS:[n,function(e){this.milliseconds=10*+e;}],SSS:[/\d{3}/,function(e){this.milliseconds=+e;}],s:[r,a("seconds")],ss:[r,a("seconds")],m:[r,a("minutes")],mm:[r,a("minutes")],H:[r,a("hours")],h:[r,a("hours")],HH:[r,a("hours")],hh:[r,a("hours")],D:[r,a("day")],DD:[n,a("day")],Do:[i,function(e){var t=o.ordinal,n=e.match(/\d+/);if(this.day=n[0],t)for(var r=1;r<=31;r+=1)t(r).replace(/\[|\]/g,"")===e&&(this.day=r);}],M:[r,a("month")],MM:[n,a("month")],MMM:[i,function(e){var t=h("months"),n=(h("monthsShort")||t.map((function(e){return e.slice(0,3)}))).indexOf(e)+1;if(n<1)throw new Error;this.month=n%12||n;}],MMMM:[i,function(e){var t=h("months").indexOf(e)+1;if(t<1)throw new Error;this.month=t%12||t;}],Y:[/[+-]?\d+/,a("year")],YY:[n,function(e){this.year=s(e);}],YYYY:[/\d{4}/,a("year")],Z:f,ZZ:f};function c(n){var r,i;r=n,i=o&&o.formats;for(var s=(n=r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g,(function(t,n,r){var o=r&&r.toUpperCase();return n||i[r]||e[r]||i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g,(function(e,t,n){return t||n.slice(1)}))}))).match(t),a=s.length,f=0;f<a;f+=1){var h=s[f],u=d[h],c=u&&u[0],l=u&&u[1];s[f]=l?{regex:c,parser:l}:h.replace(/^\[|\]$/g,"");}return function(e){for(var t={},n=0,r=0;n<a;n+=1){var i=s[n];if("string"==typeof i)r+=i.length;else {var o=i.regex,f=i.parser,h=e.slice(r),u=o.exec(h)[0];f.call(t,u),e=e.replace(u,"");}}return function(e){var t=e.afternoon;if(void 0!==t){var n=e.hours;t?n<12&&(e.hours+=12):12===n&&(e.hours=0),delete e.afternoon;}}(t),t}}return function(e,t,n){n.p.customParseFormat=!0,e&&e.parseTwoDigitYear&&(s=e.parseTwoDigitYear);var r=t.prototype,i=r.parse;r.parse=function(e){var t=e.date,r=e.utc,s=e.args;this.$u=r;var a=s[1];if("string"==typeof a){var f=!0===s[2],h=!0===s[3],u=f||h,d=s[2];h&&(d=s[2]),o=this.$locale(),!f&&d&&(o=n.Ls[d]),this.$d=function(e,t,n){try{if(["x","X"].indexOf(t)>-1)return new Date(("X"===t?1e3:1)*e);var r=c(t)(e),i=r.year,o=r.month,s=r.day,a=r.hours,f=r.minutes,h=r.seconds,u=r.milliseconds,d=r.zone,l=new Date,m=s||(i||o?1:l.getDate()),M=i||l.getFullYear(),Y=0;i&&!o||(Y=o>0?o-1:l.getMonth());var p=a||0,v=f||0,D=h||0,g=u||0;return d?new Date(Date.UTC(M,Y,m,p,v,D,g+60*d.offset*1e3)):n?new Date(Date.UTC(M,Y,m,p,v,D,g)):new Date(M,Y,m,p,v,D,g)}catch(e){return new Date("")}}(t,a,r),this.init(),d&&!0!==d&&(this.$L=this.locale(d).$L),u&&t!=this.format(a)&&(this.$d=new Date("")),o={};}else if(a instanceof Array)for(var l=a.length,m=1;m<=l;m+=1){s[1]=a[m-1];var M=n.apply(this,s);if(M.isValid()){this.$d=M.$d,this.$L=M.$L,this.init();break}m===l&&(this.$d=new Date(""));}else i.call(this,e);};}}));
});

var css_248z = ".date-picker-tooltip {\n  max-width: unset !important; }\n\n.Calendar_datePicker__33Uu5 {\n  position: relative;\n  display: inline-flex;\n  padding: 12px;\n  border-right: 1px solid #eee;\n  background-color: #f4f4f4; }\n  .Calendar_datePickerNavigationIcon__VR0GO {\n    position: absolute;\n    top: 8px;\n    left: 8px;\n    width: 32px !important;\n    height: 32px !important;\n    background-color: #fff;\n    border-radius: 16px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);\n    border: 1px solid #ddd;\n    cursor: pointer;\n    transition: 0.2s ease-out;\n    transform: rotate(90deg);\n    padding: 6px;\n    box-sizing: border-box; }\n    .Calendar_datePickerNavigationIcon__VR0GO:hover {\n      transform: translateY(-5%) rotate(90deg);\n      box-shadow: 0 2px 9px rgba(0, 0, 0, 0.08); }\n    .Calendar_datePickerNavigationIcon__VR0GO.Calendar_right__5saNx {\n      left: auto;\n      right: 8px;\n      transform: rotate(-90deg); }\n      .Calendar_datePickerNavigationIcon__VR0GO.Calendar_right__5saNx:hover {\n        transform: translateY(-5%) rotate(-90deg); }\n\n.Calendar_calendar__LqmdE {\n  color: #333;\n  max-width: 224px;\n  border: 1px solid #eee;\n  margin-right: 8px;\n  background-color: #fff; }\n  .Calendar_calendar__LqmdE:last-of-type {\n    margin-right: 0; }\n  .Calendar_calendarHeader__1Wmbj {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 8px;\n    font-size: 14px; }\n  .Calendar_calendarLabels__37Q5Y {\n    display: flex;\n    align-items: center;\n    padding: 8px;\n    border-bottom: 1px solid #eee; }\n  .Calendar_calendarLabel__2VIDV {\n    display: flex;\n    align-items: center;\n    width: 32px;\n    min-width: 32px;\n    max-width: 32px;\n    height: 28px;\n    min-height: 28px;\n    box-sizing: border-box;\n    height: auto;\n    min-height: 0;\n    font-size: 12px;\n    color: #999; }\n  .Calendar_calendarGridRow__2bhX8 {\n    display: flex;\n    align-items: center; }\n    .Calendar_calendarGridRow__2bhX8:last-child {\n      border-bottom: none; }\n      .Calendar_calendarGridRow__2bhX8:last-child .Calendar_rangePickerCalendarGridItem__1eMna {\n        border-bottom: none; }\n    .Calendar_calendarGridRowItem__lEPOi {\n      width: 32px;\n      min-width: 32px;\n      max-width: 32px;\n      height: 28px;\n      min-height: 28px;\n      box-sizing: border-box;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      padding: 8px;\n      border-right: 1px solid #eee;\n      border-bottom: 1px solid #eee;\n      cursor: pointer; }\n      .Calendar_calendarGridRowItem__lEPOi.Calendar_disabled__1W6C7 {\n        pointer-events: none; }\n      .Calendar_calendarGridRowItem__lEPOi.Calendar_disabled__1W6C7 > * {\n        opacity: 0.1; }\n      .Calendar_calendarGridRowItem__lEPOi.Calendar_invisible__3mIJ1 {\n        pointer-events: none; }\n      .Calendar_calendarGridRowItem__lEPOi.Calendar_invisible__3mIJ1 > * {\n        opacity: 0.05; }\n      .Calendar_calendarGridRowItem__lEPOi:last-child {\n        border-right: none; }\n      .Calendar_calendarGridRowItem__lEPOi:hover {\n        background-color: #f5f5f5; }\n      .Calendar_calendarGridRowItem__lEPOi.Calendar_selected__rAmCO {\n        background-color: rgba(18, 79, 160, 0.3);\n        border-color: #124fa0;\n        border-bottom: 1px solid #124fa0;\n        border-left-style: solid;\n        border-right-style: solid;\n        border-left-width: 0;\n        border-right-width: 0; }\n    .Calendar_calendarGridRowItemText__1P_5d {\n      font-size: 12px; }\n\n@keyframes Calendar_show-in__WCOTR {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n";
var styles = {"datePicker":"Calendar_datePicker__33Uu5","datePickerNavigationIcon":"Calendar_datePickerNavigationIcon__VR0GO","right":"Calendar_right__5saNx","calendar":"Calendar_calendar__LqmdE","calendarHeader":"Calendar_calendarHeader__1Wmbj","calendarLabels":"Calendar_calendarLabels__37Q5Y","calendarLabel":"Calendar_calendarLabel__2VIDV","calendarGridRow":"Calendar_calendarGridRow__2bhX8","rangePickerCalendarGridItem":"Calendar_rangePickerCalendarGridItem__1eMna","calendarGridRowItem":"Calendar_calendarGridRowItem__lEPOi","disabled":"Calendar_disabled__1W6C7","invisible":"Calendar_invisible__3mIJ1","selected":"Calendar_selected__rAmCO","calendarGridRowItemText":"Calendar_calendarGridRowItemText__1P_5d","show-in":"Calendar_show-in__WCOTR"};
styleInject(css_248z);

dayjs_min.extend(customParseFormat);
var CursorBox = styled(Box)(function (props) {
  return {
    cursor: props.disabled ? "not-allowed" : "pointer"
  };
});
var ArrowIconWrapper = styled(CursorBox)(function (props) {
  return {
    padding: 8,
    backgroundColor: props.theme.colors.grey.neon,
    position: "absolute",
    top: "16px",
    borderRadius: 6
  };
});
var Wrapper = styled(Box)(function (props) {
  return {
    position: "relative",
    borderRadius: 8,
    borderColor: props.theme.colors.grey.haptik,
    display: "inline-flex",
    padding: 0,
    flexDirection: "column",
    height: "100%",
    justifyContent: "space-between"
  };
});
var Legend = styled(Box)({
  width: 12,
  height: 12,
  padding: 0,
  borderRadius: 4,
  marginRight: 8
});
var LABELS = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];

/**
 * For every cell we run this function to see if the range is selected or not
 * so given, the date and the start date and end date we see if it falls inside (inclusively)
 */
var isSelected = function isSelected(date, from, to) {
  return date.isAfter(from, "d") && date.isBefore(to, "d") || date.isSame(from, "d") || date.isSame(to, "d");
};
var renderHeader = function renderHeader(date) {
  var month = date.format("MMMM");
  var year = date.format("YYYY");
  return /*#__PURE__*/React.createElement(Box, {
    padding: 8,
    pt: 0,
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "h2.semi-bold"
  }, "".concat(month, " ").concat(year)));
};
var renderWeeks = function renderWeeks() {
  return /*#__PURE__*/React.createElement(Box, {
    justifyContent: "space-between",
    alignItems: "center"
  }, new Array(7).fill(0).map(function (_, i) {
    return /*#__PURE__*/React.createElement(Box, {
      padding: 0,
      width: 20,
      flex: 1,
      justifyContent: "center"
    }, /*#__PURE__*/React.createElement(Text, {
      variant: "h4.semi-bold",
      color: "grey.dark"
    }, LABELS[i]));
  }));
};

/**
 * Renders each Row
 */
var renderGridRow = function renderGridRow(rowIndex, date, ranges, _ref) {
  var handleCellClick = _ref.handleCellClick,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    comparisonMaxDate = _ref.comparisonMaxDate,
    toggled = _ref.toggled,
    startDate = _ref.startDate,
    endDate = _ref.endDate,
    getTextForCell = _ref.getTextForCell,
    selectedDateInput = _ref.selectedDateInput,
    comparisonStartDate = _ref.comparisonStartDate;
  return new Array(7).fill(0).map(function (_, columnIndex) {
    var _getTextForCell = getTextForCell(date, rowIndex, columnIndex),
      text = _getTextForCell.text,
      day = _getTextForCell.day,
      invisible = _getTextForCell.invisible;
    var isStartRange = false;
    var isEndRange = false;
    var backgroundColor;
    var borderRadius = 0;
    var textColor = "black.haptik";
    ranges.forEach(function (_ref2) {
      var from = _ref2.from,
        to = _ref2.to,
        _ref2$color = _ref2.color,
        color = _ref2$color === void 0 ? "blue.pastel" : _ref2$color,
        _ref2$startEndColor = _ref2.startEndColor,
        startEndColor = _ref2$startEndColor === void 0 ? "blue.haptik" : _ref2$startEndColor;
      if (invisible) return;
      if (day.isSame(from, "d")) {
        // if its a selected start date
        isStartRange = true;
        textColor = "grey.pastel";
        borderRadius = "6px 0px 0px 6px";
      }
      if (day.isSame(to, "d")) {
        // if its a selected end date
        isEndRange = true;
        textColor = "grey.pastel";
        borderRadius = "0px 6px  6px 0px";
      }
      if (isStartRange && isEndRange) {
        borderRadius = "6px";
      }
      if (isSelected(day, from, to)) {
        // if its a selected date
        if (!backgroundColor) {
          backgroundColor = color;
          if (isStartRange || isEndRange) {
            backgroundColor = startEndColor;
          }
        } else {
          // when regular and compare dates overlap
          backgroundColor = "red.pastel";
          textColor = "red.haptik";
        }
      }
    });
    var isDisabled = false;
    if (minDate && dayjs_min(minDate).isAfter(day)) isDisabled = true;
    if (maxDate && dayjs_min(maxDate).isBefore(day)) isDisabled = true;
    if (toggled && comparisonMaxDate && dayjs_min(comparisonMaxDate).isBefore(day)) isDisabled = true;
    if (startDate && (!endDate || selectedDateInput === "endDate") && dayjs_min(startDate).isAfter(day)) {
      isDisabled = true;
    }
    if (toggled && comparisonStartDate && selectedDateInput === "comparisonEndDate" && dayjs_min(comparisonStartDate).isAfter(day)) {
      isDisabled = true;
    }
    if (isDisabled) {
      textColor = "grey.haptik";
    }
    var onCellClick = function onCellClick() {
      if (!isDisabled) {
        handleCellClick(day);
      }
    };
    return /*#__PURE__*/React.createElement(CursorBox, {
      padding: "6px 0px",
      flex: 1,
      width: 20,
      justifyContent: "center",
      onClick: onCellClick,
      borderRadius: borderRadius,
      backgroundColor: backgroundColor,
      disabled: isDisabled
    }, invisible ? null : /*#__PURE__*/React.createElement(Text, {
      variant: "body.sm",
      color: textColor
    }, text));
  });
};

/**
 * Renders the 6 * 7 grid
 */
var renderGrid = function renderGrid(date, ranges, props) {
  // eslint-disable-next-line react/prop-types
  return /*#__PURE__*/React.createElement(Box, {
    padding: 0,
    flexDirection: "column"
  }, new Array(6).fill(0).map(function (_, i) {
    return /*#__PURE__*/React.createElement(Box, {
      justifyContent: "space-between",
      padding: 4
    }, renderGridRow(i, date, ranges, props));
  }));
};
var renderCalendar = function renderCalendar(date, ranges, props, numMonths, index) {
  // eslint-disable-next-line react/prop-types
  return /*#__PURE__*/React.createElement(Box, {
    mr: index + 1 !== numMonths ? 4 : 0,
    flexDirection: "column",
    padding: 8,
    pt: 0,
    width: 300
  }, renderHeader(date), renderWeeks(), renderGrid(date, ranges, props));
};
var CalendarThemed = function CalendarThemed(_ref3) {
  var numMonths = _ref3.numMonths,
    className = _ref3.className,
    maxDate = _ref3.maxDate,
    minDate = _ref3.minDate,
    comparisonMaxDate = _ref3.comparisonMaxDate,
    toggled = _ref3.toggled,
    startDate = _ref3.startDate,
    endDate = _ref3.endDate,
    handleCellClick = _ref3.handleCellClick,
    viewingMonth = _ref3.viewingMonth,
    ranges = _ref3.ranges,
    viewNextMonth = _ref3.viewNextMonth,
    viewPreviousMonth = _ref3.viewPreviousMonth,
    getTextForCell = _ref3.getTextForCell,
    hexToRgb = _ref3.hexToRgb,
    InfoCard = _ref3.InfoCard,
    selectedDateInput = _ref3.selectedDateInput,
    comparisonStartDate = _ref3.comparisonStartDate;
  var props = {
    handleCellClick: handleCellClick,
    maxDate: maxDate,
    minDate: minDate,
    comparisonMaxDate: comparisonMaxDate,
    toggled: toggled,
    startDate: startDate,
    endDate: endDate,
    getTextForCell: getTextForCell,
    hexToRgb: hexToRgb,
    selectedDateInput: selectedDateInput,
    comparisonStartDate: comparisonStartDate
  };
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: className
  }, /*#__PURE__*/React.createElement(ArrowIconWrapper, {
    left: "24px",
    onClick: viewPreviousMonth
  }, /*#__PURE__*/React.createElement(CursorBox, {
    as: ArrowLeftIconV4,
    size: "small"
  })), /*#__PURE__*/React.createElement(ArrowIconWrapper, {
    right: "24px",
    onClick: viewNextMonth
  }, /*#__PURE__*/React.createElement(CursorBox, {
    as: ArrowRightIconV4$1,
    size: "small"
  })), /*#__PURE__*/React.createElement(Box, {
    padding: "0",
    pt: 20
  }, new Array(numMonths).fill(0).map(function (_, i) {
    return renderCalendar(viewingMonth.subtract(numMonths - i - 1, "months"), ranges, props, numMonths, i);
  })), /*#__PURE__*/React.createElement(Box, {
    bottom: 0,
    padding: "0",
    flexDirection: "column"
  }, toggled && /*#__PURE__*/React.createElement(Box, {
    padding: 8,
    pb: 16
  }, /*#__PURE__*/React.createElement(Box, {
    padding: 0,
    alignItems: "center",
    mr: 20,
    ml: 16
  }, /*#__PURE__*/React.createElement(Legend, {
    backgroundColor: "blue.haptik"
  }), /*#__PURE__*/React.createElement(Text, {
    variant: "body.md"
  }, " Current Date range")), /*#__PURE__*/React.createElement(Box, {
    padding: 0,
    alignItems: "center",
    mr: 20
  }, /*#__PURE__*/React.createElement(Legend, {
    backgroundColor: "teal.haptik"
  }), /*#__PURE__*/React.createElement(Text, {
    variant: "body.md"
  }, " Comparison")), /*#__PURE__*/React.createElement(Box, {
    padding: 0,
    alignItems: "center",
    mr: 20
  }, /*#__PURE__*/React.createElement(Legend, {
    backgroundColor: "red.pastel"
  }), /*#__PURE__*/React.createElement(Text, {
    variant: "body.md"
  }, " Conflicting Dates"))), InfoCard && /*#__PURE__*/React.createElement(Box, {
    padding: 0,
    width: "100%"
  }, InfoCard)));
};
CalendarThemed.propTypes = {
  /** The classname to appended to the outermost element */
  className: PropTypes.string,
  /** start date of the range * */
  startDate: PropTypes.string,
  /** end date of the range* */
  endDate: PropTypes.string,
  /** Dates after this date would be disabled * */
  maxDate: PropTypes.string,
  /** Dates before this date would be disabled * */
  minDate: PropTypes.string,
  /** Dates after this date would be disabled * */
  comparisonMaxDate: PropTypes.string,
  /** number of months to show in the calendar at a time */
  numMonths: PropTypes.number,
  /**  when compare is enabled */
  toggled: PropTypes.bool
};
CalendarThemed.defaultProps = {
  numMonths: 1,
  className: "",
  minDate: null,
  maxDate: null,
  comparisonMaxDate: null,
  toggled: false
};
CalendarThemed.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CalendarThemed",
  "props": {
    "numMonths": {
      "defaultValue": {
        "value": "1",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "number of months to show in the calendar at a time"
    },
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The classname to appended to the outermost element"
    },
    "minDate": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Dates before this date would be disabled *"
    },
    "maxDate": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Dates after this date would be disabled *"
    },
    "comparisonMaxDate": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Dates after this date would be disabled *"
    },
    "toggled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "when compare is enabled"
    },
    "startDate": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "start date of the range *"
    },
    "endDate": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "end date of the range*"
    }
  }
};

var LABELS$1 = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
dayjs_min.extend(customParseFormat);
var hexToRgb = function hexToRgb(hex) {
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
};

/**
 * Translates the row/column index for an actual date (we only use the month from date)
 * @Returns
 * text : <string> : the date text (ex. 23)
 * invisible : <bool> : whether the given cell is invisible (out of range)
 * day: <dayjs> : the dayjs object representing the day of the cell
 */
var getTextForCell = function getTextForCell(date, rowIndex, columnIndex) {
  var month = date.startOf("month");
  var cellNumber = rowIndex * 7 + columnIndex;
  var offset = month.day();
  var day = month.add(cellNumber - offset, "d");
  var invisible = day.month() !== month.month();
  return {
    text: "".concat(day.date()),
    day: day,
    invisible: invisible
  };
};

/**
 * For every cell we run this function to see if the range is selected or not
 * so given, the date and the start date and end date we see if it falls inside (inclusively)
 */
var isSelected$1 = function isSelected(date, from, to) {
  return date.isAfter(from, "d") && date.isBefore(to, "d") || date.isSame(from, "d") || date.isSame(to, "d");
};
var renderHeader$1 = function renderHeader(date, ranges, _ref) {
  var prefixClassName = _ref.prefixClassName;
  var month = date.format("MMMM");
  var year = date.format("YYYY");
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.calendarHeader, " ").concat(prefixClassName, "-calendar-header")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.calendarHeaderMonth, " ").concat(prefixClassName, "-calendar-header-text")
  }, month, " ", /*#__PURE__*/React.createElement("strong", null, year)));
};
var renderLabels = function renderLabels(date, ranges, _ref2) {
  var prefixClassName = _ref2.prefixClassName;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.calendarLabels, " ").concat(prefixClassName, "-labels")
  }, new Array(7).fill(0).map(function (_, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles.calendarLabel, " ").concat(prefixClassName, "-label")
    }, LABELS$1[i]);
  }));
};

/**
 * Renders each Row
 */
var renderGridRow$1 = function renderGridRow(rowIndex, date, ranges, _ref3) {
  var handleCellClick = _ref3.handleCellClick,
    mergeColor = _ref3.mergeColor,
    prefixClassName = _ref3.prefixClassName,
    minDate = _ref3.minDate,
    maxDate = _ref3.maxDate,
    comparisonMaxDate = _ref3.comparisonMaxDate,
    toggled = _ref3.toggled,
    startDate = _ref3.startDate,
    endDate = _ref3.endDate;
  return new Array(7).fill(0).map(function (_, columnIndex) {
    var _ref5;
    var _getTextForCell = getTextForCell(date, rowIndex, columnIndex),
      text = _getTextForCell.text,
      day = _getTextForCell.day,
      invisible = _getTextForCell.invisible;
    var selected = false;
    var hasLeftEdgeBorder = false;
    var hasRightEdgeBorder = false;
    var style = {};
    ranges.forEach(function (_ref4) {
      var from = _ref4.from,
        to = _ref4.to,
        _ref4$color = _ref4.color,
        color = _ref4$color === void 0 ? "#1b9cfc" : _ref4$color;
      if (invisible) return;
      if (day.isSame(from, "d")) hasLeftEdgeBorder = true;
      if (day.isSame(to, "d")) hasRightEdgeBorder = true;
      if (isSelected$1(day, from, to)) {
        selected = true;
        if (!style.backgroundColor) {
          style = {
            borderColor: color,
            borderBottomColor: color,
            backgroundColor: "rgba(".concat(Object.values(hexToRgb(color)), ", 0.3)")
          };
        } else {
          style = {
            borderLeftColor: "transparent",
            borderRightColor: "transparent",
            borderBottomColor: mergeColor,
            backgroundColor: "rgba(".concat(Object.values(hexToRgb(mergeColor)), ", 0.3)")
          };
        }
      }
    });
    var isDisabled = false;
    if (minDate && dayjs_min(minDate).isAfter(day)) isDisabled = true;
    if (maxDate && dayjs_min(maxDate).isBefore(day)) isDisabled = true;
    if (toggled && comparisonMaxDate && dayjs_min(comparisonMaxDate).isBefore(day)) isDisabled = true;
    if (startDate && !endDate && dayjs_min(startDate).isAfter(day)) isDisabled = true;
    var classNames = {
      gridRowItem: cc([styles.calendarGridRowItem, (_ref5 = {}, _defineProperty(_ref5, styles.invisible, invisible), _defineProperty(_ref5, styles.selected, selected), _defineProperty(_ref5, styles.disabled, isDisabled), _ref5), "".concat(prefixClassName, "-calendar-grid-row-item"), _defineProperty({}, "".concat(prefixClassName, "-calendar-grid-row-item-selected"), selected)]),
      gridRowItemText: cc([styles.calendarGridRowItemText, "".concat(prefixClassName, "-grid-row-item-text")])
    };
    return /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        return handleCellClick(day);
      },
      style: _objectSpread2({
        borderLeftWidth: hasLeftEdgeBorder ? 1 : 0,
        borderRightWidth: hasRightEdgeBorder ? 1 : 0
      }, style),
      className: classNames.gridRowItem
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames.gridRowItemText
    }, text));
  });
};

/**
 * Renders the 6 * 7 grid
 */
var renderGrid$1 = function renderGrid(date, ranges, props) {
  // eslint-disable-next-line react/prop-types
  var prefixClassName = props.prefixClassName;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.calendarGrid, " ").concat(prefixClassName, "-calendar-grid")
  }, new Array(6).fill(0).map(function (_, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles.calendarGridRow, " ").concat(prefixClassName, "-calendar-grid-row")
    }, renderGridRow$1(i, date, ranges, props));
  }));
};
var renderCalendar$1 = function renderCalendar(date, ranges, props) {
  // eslint-disable-next-line react/prop-types
  var prefixClassName = props.prefixClassName;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.calendar, " ").concat(prefixClassName, "-calendar")
  }, renderHeader$1(date, ranges, props), renderLabels(date, ranges, props), renderGrid$1(date, ranges, props));
};
var Calendar = function Calendar(_ref7) {
  var value = _ref7.value,
    numMonths = _ref7.numMonths,
    onChange = _ref7.onChange,
    mergeColor = _ref7.mergeColor,
    className = _ref7.className,
    prefixClassName = _ref7.prefixClassName,
    maxDate = _ref7.maxDate,
    minDate = _ref7.minDate,
    comparisonMaxDate = _ref7.comparisonMaxDate,
    toggled = _ref7.toggled,
    startDate = _ref7.startDate,
    endDate = _ref7.endDate,
    themed = _ref7.themed,
    InfoCard = _ref7.InfoCard,
    selectedDateInput = _ref7.selectedDateInput,
    comparisonStartDate = _ref7.comparisonStartDate;
  var ranges = Array.isArray(value) ? value : [{
    from: value,
    to: value
  }];
  var _React$useState = React.useState(dayjs_min()),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    viewingMonth = _React$useState2[0],
    setViewingMonth = _React$useState2[1];
  React.useEffect(function () {
    startDate && endDate && viewingMonth.format("M") !== dayjs_min(endDate).add(1, "month").format("M") && setViewingMonth(endDate);
  }, [endDate]);
  var viewNextMonth = React.useCallback(function () {
    setViewingMonth(viewingMonth.add(1, "month"));
  });
  var viewPreviousMonth = React.useCallback(function () {
    setViewingMonth(viewingMonth.subtract(1, "month"));
  });
  var handleCellClick = React.useCallback(function (day) {
    onChange(day);
  });
  var props = {
    handleCellClick: handleCellClick,
    mergeColor: mergeColor,
    prefixClassName: prefixClassName,
    maxDate: maxDate,
    minDate: minDate,
    comparisonMaxDate: comparisonMaxDate,
    toggled: toggled,
    startDate: startDate,
    endDate: endDate
  };
  if (themed) {
    return /*#__PURE__*/React.createElement(CalendarThemed, {
      numMonths: numMonths,
      className: className,
      maxDate: maxDate,
      minDate: minDate,
      comparisonMaxDate: comparisonMaxDate,
      toggled: toggled,
      startDate: startDate,
      endDate: endDate,
      handleCellClick: handleCellClick,
      viewingMonth: viewingMonth,
      ranges: ranges,
      viewNextMonth: viewNextMonth,
      viewPreviousMonth: viewPreviousMonth,
      getTextForCell: getTextForCell,
      hexToRgb: hexToRgb,
      InfoCard: InfoCard,
      selectedDateInput: selectedDateInput,
      comparisonStartDate: comparisonStartDate
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "calendar",
    className: "".concat(styles.datePicker, " ").concat(className, " ").concat(prefixClassName)
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "angle-down",
    className: "".concat(styles.datePickerNavigationIcon, " ").concat(prefixClassName, "-arrow-left"),
    onClick: viewPreviousMonth
  }), /*#__PURE__*/React.createElement(Icon, {
    src: "angle-down",
    className: "".concat(styles.datePickerNavigationIcon, " ").concat(styles.right, " ").concat(prefixClassName, "-arrow-right"),
    onClick: viewNextMonth
  }), new Array(numMonths).fill(0).map(function (_, i) {
    return renderCalendar$1(viewingMonth.subtract(numMonths - i - 1, "months"), ranges, props);
  }));
};
Calendar.propTypes = {
  /** The classname to appended to the outermost element */
  className: PropTypes.string,
  /** The prefix classname appended to all elements */
  prefixClassName: PropTypes.string,
  /** onChange callback */
  onChange: PropTypes.func,
  /** when specifying multiple ranges, this is the color for conflicting ranges */
  mergeColor: PropTypes.string,
  /** start date of the range * */
  startDate: PropTypes.string,
  /** end date of the range* */
  endDate: PropTypes.string,
  /** Dates after this date would be disabled * */
  maxDate: PropTypes.string,
  /** Dates before this date would be disabled * */
  minDate: PropTypes.string,
  /** Dates after this date would be disabled * */
  comparisonMaxDate: PropTypes.string,
  /** number of months to show in the calendar at a time */
  numMonths: PropTypes.number,
  /**  when compare is enabled */
  toggled: PropTypes.bool,
  /** The dates to highlight, can be an array of objects or a single a object */
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    from: PropTypes.object,
    to: PropTypes.object,
    color: PropTypes.string
  })), PropTypes.object]),
  /** to display the new version */
  themed: PropTypes.bool,
  /** tooltip to be displayed at bottom of themed calendar */
  InfoCard: PropTypes.node
};
Calendar.defaultProps = {
  onChange: function onChange() {},
  numMonths: 1,
  value: dayjs_min(),
  mergeColor: "#F00",
  className: "",
  prefixClassName: "",
  minDate: null,
  maxDate: null,
  comparisonMaxDate: null,
  toggled: false,
  themed: false,
  InfoCard: null
};
Calendar.classNames = {
  $prefix: "Outermost element",
  "$prefix-arrow-left": "The left arrow",
  "$prefix-arrow-right": "The right arrow",
  "$prefix-calendar": "The calendar month",
  "$prefix-calendar-header": "The calendar header",
  "$prefix-calendar-header-text": "The calendar header's text (Month)",
  "$prefix-labels": "The wrapper for labels for the days",
  "$prefix-label": "The labels for the days (Sun, Mon, Tue, etc.)",
  "$prefix-calendar-grid": "The main calendar grid div",
  "$prefix-calendar-grid-row": "Each row of the calendar grid",
  "$prefix-calendar-grid-row-item": "Each item of the grid (the square)",
  "$prefix-calendar-grid-row-item-selected": "selected grid row item",
  "$prefix-grid-row-item-text": "The label for each grid item (the day)"
};
Calendar.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Calendar",
  "props": {
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "onChange callback"
    },
    "numMonths": {
      "defaultValue": {
        "value": "1",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "number of months to show in the calendar at a time"
    },
    "value": {
      "defaultValue": {
        "value": "dayjs()",
        "computed": true
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "arrayOf",
          "value": {
            "name": "shape",
            "value": {
              "from": {
                "name": "object",
                "required": false
              },
              "to": {
                "name": "object",
                "required": false
              },
              "color": {
                "name": "string",
                "required": false
              }
            }
          }
        }, {
          "name": "object"
        }]
      },
      "required": false,
      "description": "The dates to highlight, can be an array of objects or a single a object"
    },
    "mergeColor": {
      "defaultValue": {
        "value": "\"#F00\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "when specifying multiple ranges, this is the color for conflicting ranges"
    },
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The classname to appended to the outermost element"
    },
    "prefixClassName": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The prefix classname appended to all elements"
    },
    "minDate": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Dates before this date would be disabled *"
    },
    "maxDate": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Dates after this date would be disabled *"
    },
    "comparisonMaxDate": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Dates after this date would be disabled *"
    },
    "toggled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "when compare is enabled"
    },
    "themed": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "to display the new version"
    },
    "InfoCard": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "tooltip to be displayed at bottom of themed calendar"
    },
    "startDate": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "start date of the range *"
    },
    "endDate": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "end date of the range*"
    }
  }
};

var css_248z$1 = ".TimePickerInput_timePickerInput__qghY7 {\n  padding: 4px;\n  border-radius: 4px;\n  border: 1px solid #eee;\n  width: 64px;\n  display: flex;\n  align-items: center; }\n  .TimePickerInput_timePickerInputArrow__3w_7B {\n    width: 12px !important;\n    height: 12px !important; }\n  .TimePickerInput_timePickerInputArrow__3w_7B:first-child {\n    transform: rotate(180deg); }\n  .TimePickerInput_timePickerInput__qghY7 input {\n    border: none;\n    outline: none;\n    padding: 0;\n    width: 100%;\n    font-size: 24px;\n    /* Chrome, Safari, Edge, Opera */ }\n  .TimePickerInput_timePickerInput__qghY7 input::-webkit-outer-spin-button,\n  .TimePickerInput_timePickerInput__qghY7 input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0; }\n";
var styles$1 = {"timePickerInput":"TimePickerInput_timePickerInput__qghY7","timePickerInputArrow":"TimePickerInput_timePickerInputArrow__3w_7B"};
styleInject(css_248z$1);

function TimePickerInput(_ref) {
  var innerRef = _ref.innerRef,
    onChange = _ref.onChange,
    value = _ref.value,
    increment = _ref.increment,
    prefixClassName = _ref.prefixClassName,
    max = _ref.max;
  var handleChange = React.useCallback(function (newValue) {
    if (+newValue > max) onChange("00");else onChange("".concat(newValue));
  });

  // in display we want to always show 2 digits 
  // [1 should show up as 01, but 13 should show up as 13]
  var inputValue = +value > 9 ? "".concat(+value) : "0".concat(+value);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$1.timePickerInput, " ").concat(prefixClassName)
  }, /*#__PURE__*/React.createElement("input", {
    type: "number",
    value: inputValue,
    onChange: function onChange(e) {
      return handleChange(e.target.value);
    },
    ref: innerRef,
    className: "".concat(prefixClassName, "-element")
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$1.timePickerInputArrows, " ").concat(prefixClassName, "-arrows")
  }, /*#__PURE__*/React.createElement(Icon, {
    onClick: function onClick() {
      return handleChange(+value + increment);
    },
    src: AngleDownIcon,
    className: "".concat(styles$1.timePickerInputArrow, " ").concat(prefixClassName, "-arrow")
  }), /*#__PURE__*/React.createElement(Icon, {
    onClick: function onClick() {
      return handleChange(+value - increment);
    },
    src: AngleDownIcon,
    className: "".concat(styles$1.timePickerInputArrow, " ").concat(prefixClassName, "-arrow")
  })));
}
TimePickerInput.propTypes = {
  innerRef: PropTypes.node,
  onChange: PropTypes.func,
  value: PropTypes.object,
  increment: PropTypes.number,
  max: PropTypes.number,
  prefixClassName: PropTypes.string
};
TimePickerInput.defaultProps = {
  innerRef: null,
  increment: 1,
  max: Number.MAX_SAFE_INTEGER,
  onChange: function onChange() {},
  prefixClassName: ""
};
TimePickerInput.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TimePickerInput",
  "props": {
    "innerRef": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "increment": {
      "defaultValue": {
        "value": "1",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "max": {
      "defaultValue": {
        "value": "Number.MAX_SAFE_INTEGER",
        "computed": true
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "prefixClassName": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$1$1 = ".date-picker-tooltip {\n  max-width: unset !important; }\n\n.TimePicker_timePicker__xpImR {\n  background-color: #fff;\n  border-radius: 8px;\n  margin-top: 0px;\n  display: flex;\n  align-items: flex-start;\n  color: #333;\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  font-size: 24px; }\n  .TimePicker_timePicker__xpImR > span {\n    padding: 0 4px; }\n  .TimePicker_timePickerSwitcher__15qP7 {\n    font-size: 14px;\n    font-weight: 500;\n    margin-left: 8px; }\n    .TimePicker_timePickerSwitcherValue__1vdIY {\n      color: #999;\n      transition: 0.2s ease-out;\n      cursor: pointer; }\n      .TimePicker_timePickerSwitcherValue__1vdIY:hover {\n        color: #000; }\n      .TimePicker_timePickerSwitcherValue__1vdIY.TimePicker_active__ncmKE {\n        color: #000; }\n\n@keyframes TimePicker_show-in__3SLXo {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n";
var styles$1$1 = {"timePicker":"TimePicker_timePicker__xpImR","timePickerSwitcher":"TimePicker_timePickerSwitcher__15qP7","timePickerSwitcherValue":"TimePicker_timePickerSwitcherValue__1vdIY","active":"TimePicker_active__ncmKE","show-in":"TimePicker_show-in__3SLXo"};
styleInject(css_248z$1$1);

var AMPMWrapper = styled(Box)(function (props) {
  return {
    cursor: "pointer",
    padding: "10px 10px",
    borderColor: props.theme.colors.grey.haptik
  };
});
var TimePickerThemed = function TimePickerThemed(_ref) {
  var handleAMPMChange = _ref.handleAMPMChange,
    handleHHChange = _ref.handleHHChange,
    handleMMChange = _ref.handleMMChange,
    hourValue = _ref.hourValue,
    minValue = _ref.minValue,
    ampmValue = _ref.ampmValue,
    closeTime = _ref.closeTime;
  var hourInputRef = React.useRef();
  var minsInputRef = React.useRef();
  useEnterKey(closeTime, hourInputRef);
  useEnterKey(closeTime, minsInputRef);
  var onHHBlur = function onHHBlur() {
    if (hourValue === 0) {
      handleHHChange(12);
    }
  };
  return /*#__PURE__*/React.createElement(Box, {
    alignItems: "center",
    borderRadius: 8,
    backgroundColor: "grey.pastel",
    padding: "12px"
  }, /*#__PURE__*/React.createElement(TimePickerInput$1, {
    timeValue: hourValue,
    onChange: handleHHChange,
    placeholder: "HH",
    max: 12,
    inputRef: hourInputRef,
    onBlur: onHHBlur
  }), /*#__PURE__*/React.createElement(Box, {
    padding: "0px 4px"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "h3.bold"
  }, ":")), /*#__PURE__*/React.createElement(TimePickerInput$1, {
    timeValue: minValue,
    onChange: handleMMChange,
    placeholder: "MM",
    max: 59,
    inputRef: minsInputRef
  }), /*#__PURE__*/React.createElement(Box, {
    padding: 0,
    ml: 8
  }, /*#__PURE__*/React.createElement(AMPMWrapper, {
    onClick: handleAMPMChange("AM"),
    backgroundColor: ampmValue === "AM" ? "blue.haptik" : "inherit",
    borderWidth: 1,
    borderRightWidth: 0,
    borderRadius: "4px 0px 0px 4px"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "body.md",
    color: ampmValue === "AM" ? "grey.pastel" : "inherit"
  }, "AM")), /*#__PURE__*/React.createElement(AMPMWrapper, {
    backgroundColor: ampmValue === "PM" ? "blue.haptik" : "inherit",
    onClick: handleAMPMChange("PM"),
    borderWidth: 1,
    borderRadius: " 0px 4px 4px 0px"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "body.md",
    color: ampmValue === "PM" ? "grey.pastel" : "inherit"
  }, "PM"))));
};
var TimePickerInput$1 = function TimePickerInput(_ref2) {
  var timeValue = _ref2.timeValue,
    onChange = _ref2.onChange,
    max = _ref2.max,
    placeholder = _ref2.placeholder,
    inputRef = _ref2.inputRef,
    onBlur = _ref2.onBlur;
  var validateValue = function validateValue(value) {
    if (+value <= max) {
      onChange(+value);
    } else {
      onChange(+timeValue);
    }
  };
  var onInputFocus = function onInputFocus(e) {
    e.currentTarget.select();
  };
  var time = +timeValue > 9 ? "".concat(+timeValue) : "0".concat(+timeValue);
  return /*#__PURE__*/React.createElement(Text$1, {
    placeholder: placeholder,
    value: time,
    onChange: validateValue,
    size: 2,
    controlledInput: true,
    themed: true,
    innerRef: inputRef,
    onFocus: onInputFocus,
    onBlur: onBlur
  });
};
TimePickerThemed.propTypes = {
  handleAMPMChange: PropTypes.func.isRequired,
  handleHHChange: PropTypes.func.isRequired,
  handleMMChange: PropTypes.func.isRequired,
  hourValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  minValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  ampmValue: PropTypes.string.isRequired,
  closeTime: PropTypes.func.isRequired
};
TimePickerThemed.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TimePickerThemed",
  "props": {
    "handleAMPMChange": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "handleHHChange": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "handleMMChange": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "hourValue": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": true,
      "description": ""
    },
    "minValue": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": true,
      "description": ""
    },
    "ampmValue": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "closeTime": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    }
  }
};

function TimePicker(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    prefixClassName = _ref.prefixClassName,
    themed = _ref.themed,
    closeTime = _ref.closeTime;
  var date = dayjs_min(value);
  var HHRef = React.useRef();
  var MMRef = React.useRef();
  var _React$useState = React.useState(date.format("h")),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    HH = _React$useState2[0],
    setHH = _React$useState2[1];
  var _React$useState3 = React.useState(date.format("mm")),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    MM = _React$useState4[0],
    setMM = _React$useState4[1];
  var _React$useState5 = React.useState(value.format("A")),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    AMPM = _React$useState6[0],
    setAMPM = _React$useState6[1];
  var amActiveClassName = AMPM === "AM" ? styles$1$1.active : "";
  var pmActiveClassName = AMPM === "PM" ? styles$1$1.active : "";
  var generateValue = React.useCallback(function (newHH, newMM, newAMPM) {
    var date = dayjs_min(value);
    var hoursToAdd = 0;
    if (newAMPM === "PM" && +newHH === 12) hoursToAdd = 0;else if (newAMPM === "PM") hoursToAdd = 12;else if (newAMPM === "AM" && +newHH === 12) hoursToAdd = 12;
    date = date.set("h", parseInt(newHH, 10) + hoursToAdd);
    date = date.set("m", parseInt(newMM, 10));
    if (dayjs_min(value).get("d") !== date.get("d")) date = date.set("d", dayjs_min(value).get("d"));
    return date;
  }, [date]);
  var handleHHChange = React.useCallback(function (e) {
    var newHH = e.target ? +e.target.value : e;
    if (!newHH) newHH = 0;
    if (Number.isNaN(+newHH)) return;
    if (newHH > 12) return MMRef && MMRef.current && MMRef.current.focus();
    if (newHH > 1 && MMRef && MMRef.current) {
      MMRef.current.select();
      MMRef.current.focus();
    }
    if (newHH === 0 && (!themed || themed && newHH.toString().length === 2)) newHH = 12;
    if (newHH < 1 && !themed) return;
    setHH(newHH);
    onChange(generateValue(newHH, MM, AMPM));
  }, [date]);
  var handleMMChange = React.useCallback(function (e) {
    var newMM = e.target ? e.target.value : e;
    if (!newMM) newMM = 0;
    if (Number.isNaN(+newMM)) return;
    if (newMM > 59) return;
    if (newMM < 0) return;
    setMM(newMM);
    onChange(generateValue(HH, newMM, AMPM));
  }, [date]);
  var handleAMPMChange = React.useCallback(function (newAMPM) {
    return function () {
      setAMPM(newAMPM);
      onChange(generateValue(HH, MM, newAMPM));
    };
  });
  if (themed) {
    return /*#__PURE__*/React.createElement(TimePickerThemed, {
      handleAMPMChange: handleAMPMChange,
      handleHHChange: handleHHChange,
      handleMMChange: handleMMChange,
      hourValue: HH,
      minValue: MM,
      ampmValue: AMPM,
      closeTime: closeTime
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$1$1.timePicker, " ").concat(prefixClassName)
  }, /*#__PURE__*/React.createElement(TimePickerInput, {
    autoFocus: true,
    innerRef: HHRef,
    value: HH,
    onChange: handleHHChange,
    placeholder: "HH",
    increment: 1,
    max: 12,
    prefixClassName: "".concat(prefixClassName, "-input")
  }), /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixClassName, "-separator")
  }, ":"), /*#__PURE__*/React.createElement(TimePickerInput, {
    innerRef: MMRef,
    value: MM,
    onChange: handleMMChange,
    placeholder: "MM",
    increment: 1,
    max: 59,
    prefixClassName: "".concat(prefixClassName, "-input")
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$1$1.timePickerSwitcher, " ").concat(prefixClassName, "-switcher")
  }, /*#__PURE__*/React.createElement("div", {
    onClick: handleAMPMChange("AM"),
    className: "".concat(styles$1$1.timePickerSwitcherValue, " ").concat(amActiveClassName, " ").concat(prefixClassName, "-switcher-value")
  }, "AM"), /*#__PURE__*/React.createElement("div", {
    onClick: handleAMPMChange("PM"),
    className: "".concat(styles$1$1.timePickerSwitcherValue, " ").concat(pmActiveClassName, " ").concat(prefixClassName, "-switcher-value")
  }, "PM")));
}
TimePicker.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.object,
  prefixClassName: PropTypes.string,
  themed: PropTypes.bool,
  closeTime: PropTypes.func.isRequired
};
TimePicker.defaultProps = {
  onChange: function onChange() {},
  value: dayjs_min(),
  prefixClassName: "",
  themed: false
};
TimePicker.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TimePicker",
  "props": {
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "defaultValue": {
        "value": "dayjs()",
        "computed": true
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "prefixClassName": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "themed": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "closeTime": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    }
  }
};

var css_248z$2 = ".Time_date__2Z8yY {\n  position: relative;\n  margin-bottom: 24px; }\n\n.Time_dateLabel__hukz9 {\n  display: block;\n  color: #666;\n  font-size: 12px;\n  font-weight: 600;\n  margin-bottom: 6px;\n  margin-left: 2px;\n  transition: 0.2s ease-out; }\n  .Time_dateLabel__hukz9.Time_focused__1UPxT {\n    color: #124fa0; }\n\n.Time_dateInputWrapper__34Fsi {\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  overflow: hidden;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #fff;\n  padding: 4px 8px;\n  box-sizing: border-box;\n  cursor: pointer;\n  outline: none;\n  transition: 0.2s ease-out; }\n  .Time_dateInputWrapper__34Fsi.Time_focused__1UPxT {\n    border-color: #124fa0; }\n  .Time_dateInputWrapper__34Fsi.Time_disabled__HCGGF {\n    pointer-events: none;\n    background-color: #eee; }\n\n.Time_dateInput__2_BmJ {\n  border: none;\n  outline: none;\n  width: 100%;\n  font-size: 12px;\n  white-space: nowrap; }\n  .Time_dateInput__2_BmJ span {\n    opacity: 0.3; }\n\n.Time_dateError__11NVd .Time_dateLabel__hukz9 {\n  color: #f44336; }\n\n.Time_dateError__11NVd .Time_dateInputWrapper__34Fsi {\n  border-color: #f44336;\n  background-color: rgba(244, 67, 54, 0.05); }\n\n.Time_dateInputSubtext__2NlwP {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 4px;\n  font-size: 12px;\n  position: absolute;\n  bottom: 0;\n  transform: translate3d(0, 100%, 0);\n  padding-top: 4px; }\n\n.Time_dateInputSubtextError__1qlVk {\n  color: #ff0c0c;\n  opacity: 0.8; }\n\n.Time_datePickrInput__1Zqla {\n  position: absolute;\n  left: 0;\n  bottom: 0; }\n\n.Time_dateInputZeroState__1b9la {\n  font-family: 'Roboto';\n  display: block;\n  padding: 16px;\n  font-size: 14px;\n  opacity: 0.4; }\n";
var styles$2 = {"date":"Time_date__2Z8yY","dateLabel":"Time_dateLabel__hukz9","focused":"Time_focused__1UPxT","dateInputWrapper":"Time_dateInputWrapper__34Fsi","disabled":"Time_disabled__HCGGF","dateInput":"Time_dateInput__2_BmJ","dateError":"Time_dateError__11NVd","dateInputSubtext":"Time_dateInputSubtext__2NlwP","dateInputSubtextError":"Time_dateInputSubtextError__1qlVk","datePickrInput":"Time_datePickrInput__1Zqla","dateInputZeroState":"Time_dateInputZeroState__1b9la"};
styleInject(css_248z$2);

var Time = /*#__PURE__*/function (_React$Component) {
  _inherits(Time, _React$Component);
  var _super = _createSuper(Time);
  function Time(props) {
    var _this;
    _classCallCheck(this, Time);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "_DOMNode", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "_getParsedDate", function () {
      var value = _this.props.value;
      var format = "hh:mm A";
      var date = _this._getParsedValueFromDate(value || new Date());
      if (!date.isValid()) return "Invalid Time";
      return "".concat(date.format(format));
    });
    _defineProperty(_assertThisInitialized(_this), "_getParsedValueFromDate", function (value) {
      return dayjs_min(value);
    });
    _defineProperty(_assertThisInitialized(_this), "_handleChange", function (date) {
      _this.setState({
        value: date
      });
    });
    _defineProperty(_assertThisInitialized(_this), "toggleDate", function () {
      if (!_this.props.disabled) {
        _this.setState(function (state) {
          return {
            active: !state.active,
            focused: !state.active
          };
        });
        _this.props.toggleStatus && _this.props.toggleStatus(true);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "closeDate", function () {
      _this.setState({
        active: false,
        focused: false
      });
      _this.props.onChange(_this.state.value.toDate());
      _this.props.toggleStatus && _this.props.toggleStatus(false);
    });
    _this.state = {
      active: false,
      focused: false,
      value: dayjs_min(props.value) || dayjs_min()
    };
    return _this;
  }
  _createClass(Time, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        error = _this$props.error,
        disabled = _this$props.disabled,
        prefixClassName = _this$props.prefixClassName,
        themed = _this$props.themed,
        hideTooltipArrow = _this$props.hideTooltipArrow;
      var errorClassName = error ? styles$2.dateError : "";
      var disabledClassName = disabled ? styles$2.disabled : "";
      return /*#__PURE__*/React.createElement("div", {
        "data-testid": "time",
        className: "".concat(styles$2.date, " ").concat(errorClassName, " ").concat(disabledClassName, " ").concat(prefixClassName, " ").concat(className)
      }, this.renderLabel(), this.renderInput(), /*#__PURE__*/React.createElement(Tooltip, {
        onClose: this.closeDate,
        attachTo: this._DOMNode,
        active: this.state.active,
        offset: this.props.offset,
        prefixClassName: "".concat(prefixClassName, "-tooltip"),
        position: this.props.position,
        hideArrow: hideTooltipArrow
      }, /*#__PURE__*/React.createElement(TimePicker, {
        prefixClassName: "".concat(prefixClassName, "-picker"),
        value: this.state.value,
        onChange: this._handleChange,
        themed: themed,
        closeTime: this.closeDate
      })));
    }
  }, {
    key: "renderLabel",
    value: function renderLabel() {
      var _this$props2 = this.props,
        prefixClassName = _this$props2.prefixClassName,
        error = _this$props2.error,
        label = _this$props2.label,
        themed = _this$props2.themed;
      if (!label || themed) return null;
      return /*#__PURE__*/React.createElement(Label, {
        focused: this.state.focused,
        error: error,
        className: "".concat(prefixClassName, "-label")
      }, label);
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this2 = this;
      var _this$state = this.state,
        focused = _this$state.focused,
        active = _this$state.active;
      var _this$props3 = this.props,
        placeholder = _this$props3.placeholder,
        prefixClassName = _this$props3.prefixClassName,
        onFocus = _this$props3.onFocus,
        onBlur = _this$props3.onBlur,
        error = _this$props3.error,
        disabled = _this$props3.disabled,
        themed = _this$props3.themed,
        manuallyFocused = _this$props3.manuallyFocused,
        prefixIcon = _this$props3.prefixIcon,
        label = _this$props3.label;
      var parsedValue = this._getParsedDate();
      var onInputfocus = function onInputfocus(e) {
        _this2.toggleDate();
        onFocus(e);
      };
      if (themed) {
        return /*#__PURE__*/React.createElement(Text$1, {
          prefixClassName: "".concat(prefixClassName, "-input"),
          innerRef: this._DOMNode,
          onKeyDown: this._handleKeyDown,
          onFocus: onInputfocus,
          onBlur: onBlur,
          active: active,
          value: parsedValue,
          placeholder: placeholder,
          error: error,
          disabled: disabled,
          themed: true,
          prefixIcon: prefixIcon,
          manuallyFocused: focused || manuallyFocused,
          controlledInput: true,
          label: label
        });
      }
      return /*#__PURE__*/React.createElement(TextInput, {
        prefixClassName: "".concat(prefixClassName, "-input"),
        innerRef: this._DOMNode,
        onKeyDown: this._handleKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseDown: this.toggleDate,
        focused: focused,
        active: active,
        value: parsedValue,
        placeholder: placeholder,
        error: error,
        editable: false,
        disabled: disabled,
        postfixComponent: /*#__PURE__*/React.createElement(Icon, {
          src: AngleDownIcon
        })
      });
    }
  }]);
  return Time;
}(React.Component);
Time.propTypes = {
  /** The classname to appended to the outermost element */
  className: PropTypes.string,
  /** If the input is disabled (non-editable) */
  disabled: PropTypes.bool,
  /** If the input has an error. */
  error: PropTypes.bool,
  /** The prefix classname appended to all elements */
  prefixClassName: PropTypes.string,
  /** Label text */
  label: PropTypes.string,
  /** The offset of the tooltip containing the picker */
  offset: PropTypes.object,
  /** onBlur callback */
  onBlur: PropTypes.func,
  /** onChange callback */
  onChange: PropTypes.func,
  /** onFocus callback */
  onFocus: PropTypes.func,
  /** The input placeholder (when no value is selected) */
  placeholder: PropTypes.string,
  /** The position of the tooltip */
  position: PropTypes.string,
  /** The value of the input */
  value: PropTypes.string,
  /** Render Themed version */
  themed: PropTypes.bool,
  /** hides arrow rendered by tooltip */
  hideTooltipArrow: PropTypes.bool,
  /** status whether the time tooltip is opened or closed */
  toggleStatus: PropTypes.func,
  /** focus the input manually */
  manuallyFocused: PropTypes.bool,
  /** Icon to be displayed within input box */
  prefixIcon: PropTypes.node
};
Time.defaultProps = {
  label: "",
  className: "",
  prefixClassName: "",
  value: "",
  placeholder: "",
  error: false,
  disabled: false,
  offset: null,
  position: null,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  themed: false,
  hideTooltipArrow: false,
  toggleStatus: function toggleStatus() {},
  manuallyFocused: false
};
Time.classNames = {
  $prefix: "Added to the wrapper",
  "$prefix-label": "Added to the wrapper",
  "$prefix-input": "Added to the wrapper",
  "$prefix-tooltip": "Added to the wrapper",
  "$prefix-tooltip-overlay": "Added to the wrapper",
  "$prefix-tooltip-inner": "Added to the wrapper",
  "$prefix-tooltip-caret": "Added to the wrapper",
  "$prefix-tooltip-body": "Added to the wrapper",
  "$prefix-picker": "Added to the wrapper",
  "$prefix-picker-input": "Added to the wrapper",
  "$prefix-picker-input-element": "Added to the wrapper",
  "$prefix-picker-input-arrows": "Added to the wrapper",
  "$prefix-picker-input-arrow": "Added to the wrapper",
  "$prefix-picker-switcher": "Added to the wrapper",
  "$prefix-picker-switcher-value": "Added to the wrapper"
};
Time.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "renderLabel",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "renderInput",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_getParsedDate",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_getParsedValueFromDate",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_handleChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "date",
      "type": null
    }],
    "returns": null
  }, {
    "name": "toggleDate",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "closeDate",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "Time",
  "props": {
    "label": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Label text"
    },
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The classname to appended to the outermost element"
    },
    "prefixClassName": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The prefix classname appended to all elements"
    },
    "value": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The value of the input"
    },
    "placeholder": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The input placeholder (when no value is selected)"
    },
    "error": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "If the input has an error."
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "If the input is disabled (non-editable)"
    },
    "offset": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "The offset of the tooltip containing the picker"
    },
    "position": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The position of the tooltip"
    },
    "onFocus": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "onFocus callback"
    },
    "onBlur": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "onBlur callback"
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "onChange callback"
    },
    "themed": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Render Themed version"
    },
    "hideTooltipArrow": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "hides arrow rendered by tooltip"
    },
    "toggleStatus": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "status whether the time tooltip is opened or closed"
    },
    "manuallyFocused": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "focus the input manually"
    },
    "prefixIcon": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Icon to be displayed within input box"
    }
  }
};

var CalendarIcon = function CalendarIcon(props) {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2140_5825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 3.81818H19V2H17V3.81818H7V2H5V3.81818H4C2.9 3.81818 2 4.63636 2 5.63636V20.1818C2 21.1818 2.9 22 4 22H20C21.1 22 22 21.1818 22 20.1818V5.63636C22 4.63636 21.1 3.81818 20 3.81818ZM20 20.1818H4V10.1818H20V20.1818ZM20 8.36364H4V5.63636H20V8.36364Z",
    fill: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep)
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2140_5825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  })))));
};
CalendarIcon.propTypes = {
  iconColor: PropTypes.string
};
CalendarIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CalendarIcon",
  "props": {
    "iconColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
var CalendarIcon$1 = withTheme(CalendarIcon);

var TimeIconV2 = function TimeIconV2(props) {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1 12C21.1 17.0258 17.0258 21.1 12 21.1C6.97421 21.1 2.9 17.0258 2.9 12C2.9 6.97421 6.97421 2.9 12 2.9C17.0258 2.9 21.1 6.97421 21.1 12Z",
    stroke: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep),
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5V12.5L16 14.5",
    stroke: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep),
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
TimeIconV2.propTypes = {
  iconColor: PropTypes.string
};
TimeIconV2.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TimeIconV2",
  "props": {
    "iconColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
var TimeIconV2$1 = withTheme(TimeIconV2);

var css_248z$3 = ".Input_input__11F-i {\n  position: relative;\n  margin-bottom: 0px;\n  margin-right: 8px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  max-width: 140px; }\n  .Input_input__11F-i input {\n    width: 100%;\n    outline: none;\n    border: none;\n    background-color: transparent;\n    padding: 4px;\n    font-size: 11px;\n    padding-left: 42px;\n    box-sizing: border-box;\n    min-width: 0;\n    cursor: pointer; }\n  .Input_inputLabel__116rs {\n    position: absolute;\n    font-size: 10px;\n    color: #999;\n    top: 52%;\n    left: 6px;\n    transform: translateY(-50%);\n    text-transform: uppercase; }\n  .Input_input__11F-i.Input_endInput__1xUUF input {\n    padding-left: 31px; }\n  .Input_input__11F-i.Input_focused__1a4aH {\n    border: 1px solid #124fa0; }\n  .Input_input__11F-i.Input_compare__3vLwo.Input_focused__1a4aH {\n    border-color: #f1c40f; }\n";
var styles$3 = {"input":"Input_input__11F-i","inputLabel":"Input_inputLabel__116rs","endInput":"Input_endInput__1xUUF","focused":"Input_focused__1a4aH","compare":"Input_compare__3vLwo"};
styleInject(css_248z$3);

function Input(_ref) {
  var label = _ref.label,
    value = _ref.value,
    className = _ref.className,
    disabled = _ref.disabled,
    onFocus = _ref.onFocus,
    focused = _ref.focused,
    compare = _ref.compare,
    prefixClassName = _ref.prefixClassName;
  var date = dayjs_min.isDayjs(value) ? dayjs_min(value).format("DD MMM, YYYY") : "";
  var focusedClassName = focused ? styles$3.focused : "";
  var compareClassName = compare ? styles$3.compare : "";
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$3.input, " ").concat(className, " ").concat(compareClassName, " ").concat(focusedClassName, " ").concat(prefixClassName)
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(styles$3.inputLabel, " ").concat(prefixClassName, "-label")
  }, label), /*#__PURE__*/React.createElement("input", {
    onFocus: onFocus,
    value: date,
    className: "".concat(styles$3.inputField, " ").concat(prefixClassName, "-input"),
    placeholder: "Selecting",
    disabled: disabled
  }));
}
Input.propTypes = {
  className: PropTypes.string,
  compare: PropTypes.bool,
  disabled: PropTypes.bool,
  focused: PropTypes.bool,
  label: PropTypes.string,
  onFocus: PropTypes.func,
  prefixClassName: PropTypes.string,
  value: PropTypes.object
};
Input.defaultProps = {
  className: "",
  compare: false,
  disabled: false,
  focused: false,
  label: "",
  onFocus: function onFocus() {},
  prefixClassName: "",
  value: {}
};
Input.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Input",
  "props": {
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "compare": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "focused": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "label": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onFocus": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "prefixClassName": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$1$2 = ".Inputs_inputsColumn__7-mQ4 {\n  display: flex;\n  flex-direction: column;\n  padding: 20px 12px; }\n  .Inputs_inputsColumnLabel__Dj1Xz {\n    font-size: 14px;\n    margin-bottom: 2px; }\n  .Inputs_inputsColumnHint__2BOry {\n    font-size: 10px;\n    color: #999;\n    margin-bottom: 14px; }\n\n.Inputs_inputsItems__1V8SG {\n  display: flex;\n  margin-bottom: 24px;\n  animation: Inputs_show-in__3jt9Q 0.2s ease-out both;\n  animation-delay: 0.05s; }\n  .Inputs_inputsItems__1V8SG:last-of-type {\n    margin-bottom: 0; }\n\n.Inputs_inputsButtons__37A6P {\n  display: flex;\n  margin-bottom: 12px;\n  animation: Inputs_show-in__3jt9Q 0.2s ease-out both; }\n  .Inputs_inputsButtons__37A6P .Inputs_inputsButton__ad8bd {\n    margin-right: 8px;\n    font-size: 10px; }\n    .Inputs_inputsButtons__37A6P .Inputs_inputsButton__ad8bd:last-child {\n      margin-right: 0; }\n";
var styles$1$2 = {"inputsColumn":"Inputs_inputsColumn__7-mQ4","inputsColumnLabel":"Inputs_inputsColumnLabel__Dj1Xz","inputsColumnHint":"Inputs_inputsColumnHint__2BOry","inputsItems":"Inputs_inputsItems__1V8SG","show-in":"Inputs_show-in__3jt9Q","inputsButtons":"Inputs_inputsButtons__37A6P","inputsButton":"Inputs_inputsButton__ad8bd"};
styleInject(css_248z$1$2);

/**
 * Retrieves some stats for the given start and end date
 * such as if the combination of dates matches any of the helper buttons
 * (Today, Yesterday, Last 7 days etc.)
 */
var getDateStats = function getDateStats(startDate, endDate) {
  var today = dayjs_min();
  var yesterday = dayjs_min().subtract(1, "d");
  var isSame = startDate.isSame(endDate, "d");
  var isToday = isSame && startDate.isSame(today, "d");
  var isYesterday = isSame && startDate.isSame(yesterday, "d");
  var isLast7Days = today.subtract(6, "d").isSame(startDate, "d") && endDate && endDate.isSame(today, "d");
  var isLast30Days = today.subtract(29, "d").isSame(startDate, "d") && endDate && endDate.isSame(today, "d");
  return {
    isToday: isToday,
    isYesterday: isYesterday,
    isLast7Days: isLast7Days,
    isLast30Days: isLast30Days
  };
};
function Shortcuts(_ref) {
  var startDate = _ref.startDate,
    endDate = _ref.endDate,
    onChange = _ref.onChange,
    prefixClassName = _ref.prefixClassName;
  var _getDateStats = getDateStats(startDate, endDate),
    isToday = _getDateStats.isToday,
    isYesterday = _getDateStats.isYesterday,
    isLast7Days = _getDateStats.isLast7Days,
    isLast30Days = _getDateStats.isLast30Days;
  var today = dayjs_min().startOf("day");
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$1$2.inputsButtons, " ").concat(prefixClassName)
  }, /*#__PURE__*/React.createElement(Button, {
    primary: isToday,
    type: isToday ? "primary" : "default",
    className: "".concat(styles$1$2.inputsButton, " ").concat(prefixClassName, "-button"),
    onClick: function onClick() {
      return onChange(today, today.endOf("day"));
    }
  }, "Today"), /*#__PURE__*/React.createElement(Button, {
    primary: isYesterday,
    type: isYesterday ? "primary" : "default",
    className: "".concat(styles$1$2.inputsButton, " ").concat(prefixClassName, "-button"),
    onClick: function onClick() {
      return onChange(today.subtract(1, "d").startOf("day"), today.subtract(1, "d").endOf("day"));
    }
  }, "Yesterday"), /*#__PURE__*/React.createElement(Button, {
    primary: isLast7Days,
    type: isLast7Days ? "primary" : "default",
    className: "".concat(styles$1$2.inputsButton, " ").concat(prefixClassName, "-button"),
    onClick: function onClick() {
      return onChange(today.subtract(6, "d").startOf("day"), today.endOf("day"));
    }
  }, "Last 7 Days"), /*#__PURE__*/React.createElement(Button, {
    primary: isLast30Days,
    type: isLast30Days ? "primary" : "default",
    className: "".concat(styles$1$2.inputsButton, " ").concat(prefixClassName, "-button"),
    onClick: function onClick() {
      return onChange(today.subtract(29, "d").startOf("day"), today.endOf("day"));
    }
  }, "Last 30 Days"));
}
function Inputs(_ref2) {
  var startDate = _ref2.startDate,
    endDate = _ref2.endDate,
    onChange = _ref2.onChange,
    _onFocus = _ref2.onFocus,
    selectingKey = _ref2.selectingKey,
    prefixClassName = _ref2.prefixClassName;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$1$2.inputsColumn, " ").concat(prefixClassName)
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$1$2.inputsColumnLabel, " ").concat(prefixClassName, "-label")
  }, "Select Date"), /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$1$2.inputsColumnHint, " ").concat(prefixClassName, "-hint")
  }, "Tap on the calendar to define custom date ranges"), /*#__PURE__*/React.createElement(Shortcuts, {
    prefixClassName: "".concat(prefixClassName, "-shortcuts"),
    startDate: startDate,
    endDate: endDate,
    onChange: onChange
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$1$2.inputsItems, " ").concat(prefixClassName, "-input-items")
  }, /*#__PURE__*/React.createElement(Input, {
    label: "Start",
    key: "startDate",
    value: startDate,
    onFocus: function onFocus() {
      return _onFocus("startDate");
    },
    focused: selectingKey === "startDate",
    prefixClassName: "".concat(prefixClassName, "-input-item")
  }), /*#__PURE__*/React.createElement(Input, {
    className: styles$1$2.endInput,
    label: "End",
    key: "endDate",
    value: endDate,
    onFocus: function onFocus() {
      return _onFocus("endDate");
    },
    focused: selectingKey === "endDate",
    prefixClassName: "".concat(prefixClassName, "-input-item")
  })));
}
Inputs.propTypes = {
  endDate: PropTypes.instanceOf(dayjs_min).isRequired,
  startDate: PropTypes.instanceOf(dayjs_min).isRequired,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  prefixClassName: PropTypes.string,
  selectingKey: PropTypes.string
};
Inputs.defaultProps = {
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  prefixClassName: "",
  selectingKey: ""
};
Shortcuts.propTypes = {
  onChange: PropTypes.func,
  prefixClassName: PropTypes.string,
  endDate: PropTypes.instanceOf(dayjs_min),
  startDate: PropTypes.instanceOf(dayjs_min)
};
Shortcuts.defaultProps = {
  onChange: function onChange() {},
  prefixClassName: ""
};
Inputs.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Inputs",
  "props": {
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onFocus": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "prefixClassName": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "selectingKey": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "endDate": {
      "type": {
        "name": "instanceOf",
        "value": "dayjs"
      },
      "required": true,
      "description": ""
    },
    "startDate": {
      "type": {
        "name": "instanceOf",
        "value": "dayjs"
      },
      "required": true,
      "description": ""
    }
  }
};

var css_248z$2$1 = ".Comparison_inputs__3sxGe {\n  display: flex;\n  flex-direction: column;\n  padding: 20px 12px;\n  padding-top: 0; }\n  .Comparison_inputsLabel__1HmNL {\n    font-size: 14px;\n    margin-bottom: 2px; }\n  .Comparison_inputsHint__2p_Tz {\n    font-size: 10px;\n    color: #999;\n    margin-bottom: 14px; }\n  .Comparison_inputsItems__2h2UQ {\n    display: flex;\n    margin-bottom: 24px;\n    animation: Comparison_show-in__3HFz- 0.2s ease-out both;\n    animation-delay: 0.05s; }\n    .Comparison_inputsItems__2h2UQ:last-of-type {\n      margin-bottom: 0; }\n  .Comparison_inputsButtons__s72G3 {\n    display: flex;\n    margin-bottom: 12px;\n    animation: Comparison_show-in__3HFz- 0.2s ease-out both; }\n    .Comparison_inputsButtons__s72G3 .Comparison_inputsButton__Pj0tM {\n      margin-right: 8px;\n      font-size: 10px; }\n      .Comparison_inputsButtons__s72G3 .Comparison_inputsButton__Pj0tM:last-child {\n        margin-right: 0; }\n      .Comparison_inputsButtons__s72G3 .Comparison_inputsButton__Pj0tM.Comparison_compare__1hPX2 {\n        background-color: #f1c40f;\n        border-color: #f1c40f;\n        color: #fff; }\n  .Comparison_inputsCheckbox__16HSR {\n    font-size: 12px;\n    margin-bottom: 12px;\n    margin-left: 1px; }\n    .Comparison_inputsCheckbox__16HSR-text {\n      font-size: 12px; }\n      .Comparison_inputsCheckbox__16HSR-text.selected {\n        color: #f1c40f; }\n    .Comparison_inputsCheckbox__16HSR-box {\n      width: 12px;\n      height: 12px;\n      margin-right: 4px; }\n      .Comparison_inputsCheckbox__16HSR-box.selected {\n        background-color: #f1c40f;\n        border-color: #f1c40f; }\n";
var styles$2$1 = {"inputs":"Comparison_inputs__3sxGe","inputsLabel":"Comparison_inputsLabel__1HmNL","inputsHint":"Comparison_inputsHint__2p_Tz","inputsItems":"Comparison_inputsItems__2h2UQ","show-in":"Comparison_show-in__3HFz-","inputsButtons":"Comparison_inputsButtons__s72G3","inputsButton":"Comparison_inputsButton__Pj0tM","compare":"Comparison_compare__1hPX2","inputsCheckbox":"Comparison_inputsCheckbox__16HSR"};
styleInject(css_248z$2$1);

function Shortcuts$1(_ref) {
  var startDate = _ref.startDate,
    endDate = _ref.endDate,
    onChange = _ref.onChange,
    prefixClassName = _ref.prefixClassName,
    comparisonStartDate = _ref.comparisonStartDate,
    comparisonEndDate = _ref.comparisonEndDate;
  var numDays = endDate ? endDate.diff(startDate, "d") + 1 : 0;
  var prevComparisonStartDate = startDate.subtract(numDays, "d");
  var prevComparisonEndDate = startDate.subtract(1, "d");
  var isPreviousPeriod = comparisonStartDate && comparisonEndDate && comparisonStartDate.isSame(prevComparisonStartDate) && comparisonEndDate.isSame(prevComparisonEndDate);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$2$1.inputsButtons, " ").concat(prefixClassName)
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      onChange(startDate.subtract(numDays, "days"), startDate.subtract(1, "days"));
    },
    className: "".concat(styles$2$1.inputsButton, " ").concat(isPreviousPeriod ? styles$2$1.compare : "", " ").concat(prefixClassName, "-button"),
    primary: isPreviousPeriod
  }, "Previous Period"), /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      onChange(null, null, "comparisonStartDate");
    },
    className: "".concat(styles$2$1.inputsButton, " ").concat(!isPreviousPeriod ? styles$2$1.compare : "", " ").concat(prefixClassName, "-button"),
    primary: !isPreviousPeriod
  }, "Custom"));
}
function Comparison(_ref2) {
  var comparisonStartDate = _ref2.comparisonStartDate,
    comparisonEndDate = _ref2.comparisonEndDate,
    onToggle = _ref2.onToggle,
    onChange = _ref2.onChange,
    selectingKey = _ref2.selectingKey,
    toggled = _ref2.toggled,
    startDate = _ref2.startDate,
    endDate = _ref2.endDate,
    prefixClassName = _ref2.prefixClassName,
    _onFocus = _ref2.onFocus;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$2$1.inputs, " ").concat(prefixClassName)
  }, /*#__PURE__*/React.createElement(Checkbox.Item, {
    label: "Compare",
    value: toggled,
    className: "".concat(styles$2$1.inputsCheckbox, " ").concat(prefixClassName, "-toggle"),
    onChange: onToggle
  }), toggled ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shortcuts$1, {
    prefixClassName: "".concat(prefixClassName, "-shortcuts"),
    startDate: startDate,
    endDate: endDate,
    comparisonStartDate: comparisonStartDate,
    comparisonEndDate: comparisonEndDate,
    onChange: onChange
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$2$1.inputsItems, " ").concat(prefixClassName, "-input-items")
  }, /*#__PURE__*/React.createElement(Input, {
    label: "Start",
    key: "comparisonStartDate",
    value: comparisonStartDate,
    onFocus: function onFocus() {
      return _onFocus("comparisonStartDate");
    },
    focused: selectingKey === "comparisonStartDate",
    compare: true,
    prefixClassName: "".concat(prefixClassName, "-input-item")
  }), /*#__PURE__*/React.createElement(Input, {
    className: styles$2$1.endInput,
    label: "End",
    key: "comparisonEndDate",
    value: comparisonEndDate,
    onFocus: function onFocus() {
      return _onFocus("comparisonEndDate");
    },
    focused: selectingKey === "comparisonEndDate",
    compare: true,
    prefixClassName: "".concat(prefixClassName, "-input-item")
  }))) : null);
}
Comparison.propTypes = {
  comparisonEndDate: PropTypes.instanceOf(dayjs_min),
  comparisonStartDate: PropTypes.instanceOf(dayjs_min),
  endDate: PropTypes.instanceOf(dayjs_min),
  onChange: PropTypes.func,
  onToggle: PropTypes.func,
  onFocus: PropTypes.func,
  prefixClassName: PropTypes.string,
  selectingKey: PropTypes.string,
  startDate: PropTypes.instanceOf(dayjs_min),
  toggled: PropTypes.bool
};
Comparison.defaultProps = {
  onChange: function onChange() {},
  onToggle: function onToggle() {},
  onFocus: function onFocus() {},
  prefixClassName: "",
  selectingKey: "",
  toggled: false
};
Shortcuts$1.propTypes = {
  onChange: PropTypes.func,
  prefixClassName: PropTypes.string,
  endDate: PropTypes.instanceOf(dayjs_min),
  startDate: PropTypes.instanceOf(dayjs_min),
  comparisonEndDate: PropTypes.instanceOf(dayjs_min),
  comparisonStartDate: PropTypes.instanceOf(dayjs_min)
};
Shortcuts$1.defaultProps = {
  onChange: function onChange() {},
  prefixClassName: ""
};
Comparison.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Comparison",
  "props": {
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onToggle": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onFocus": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "prefixClassName": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "selectingKey": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "toggled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "comparisonEndDate": {
      "type": {
        "name": "instanceOf",
        "value": "dayjs"
      },
      "required": false,
      "description": ""
    },
    "comparisonStartDate": {
      "type": {
        "name": "instanceOf",
        "value": "dayjs"
      },
      "required": false,
      "description": ""
    },
    "endDate": {
      "type": {
        "name": "instanceOf",
        "value": "dayjs"
      },
      "required": false,
      "description": ""
    },
    "startDate": {
      "type": {
        "name": "instanceOf",
        "value": "dayjs"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$3$1 = ".date-picker-tooltip > div:nth-child(2) > div:nth-child(2) {\n  max-width: unset !important; }\n\n.RangePicker_rangePicker__2zWbG {\n  background-color: #fff;\n  border-radius: 8px;\n  margin-top: 8px;\n  min-width: 500px;\n  min-height: 240px;\n  display: flex;\n  color: #333; }\n\n@keyframes RangePicker_show-in__3A5ds {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n";
var styles$3$1 = {"rangePicker":"RangePicker_rangePicker__2zWbG","show-in":"RangePicker_show-in__3A5ds"};
styleInject(css_248z$3$1);

var _templateObject;
var TimeInputWrapper = styled(Time)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 0px !important;\n"])));
var ErrorComponent = function ErrorComponent() {
  return /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "red.pastel",
    borderRadius: 4,
    mt: 4
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "body.md",
    color: "red.haptik"
  }, "Please ensure that the \"from\" time is earlier than the \"to\" time!"));
};
var Wrapper$1 = styled(Box)(function (props) {
  return {
    flexDirection: "column",
    position: "relative",
    padding: "8px 12px",
    paddingTop: 20,
    borderWidth: 0,
    borderLeftWidth: 1,
    borderColor: props.theme.colors.grey.haptik,
    boxShadow: "-4px 4px 10px 0px rgb(0 0 0 / 20%)"
  };
});

/**
 * Retrieves some stats for the given start and end date
 * such as if the combination of dates matches any of the helper buttons
 * (Today, Yesterday, Last 7 days etc.)
 */
var getDateStats$1 = function getDateStats(startDate, endDate) {
  var today = dayjs_min();
  var yesterday = dayjs_min().subtract(1, "d");
  var isSame = startDate.isSame(endDate, "d");
  var selectedRange = "Custom";
  if (isSame && startDate.isSame(today, "d")) {
    selectedRange = "Today";
  } else if (isSame && startDate.isSame(yesterday, "d")) {
    selectedRange = "Yesterday";
  } else if (today.subtract(6, "d").isSame(startDate, "d") && endDate && endDate.isSame(today, "d")) {
    selectedRange = "Last 7 days";
  } else if (today.subtract(29, "d").isSame(startDate, "d") && endDate && endDate.isSame(today, "d")) {
    selectedRange = "Last 30 days";
  }
  return selectedRange;
};
var InputThemed = function InputThemed(_ref) {
  var startDate = _ref.startDate,
    endDate = _ref.endDate,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    selectingKey = _ref.selectingKey,
    comparisonStartDate = _ref.comparisonStartDate,
    comparisonEndDate = _ref.comparisonEndDate,
    onToggle = _ref.onToggle,
    toggled = _ref.toggled,
    withTime = _ref.withTime,
    withComparison = _ref.withComparison,
    setTime = _ref.setTime,
    startTime = _ref.startTime,
    endTime = _ref.endTime,
    comparisonEndTime = _ref.comparisonEndTime,
    comparisonStartTime = _ref.comparisonStartTime,
    prefixClassName = _ref.prefixClassName;
  var wrapperRef = useRef();
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    dateRange = _useState2[0],
    setDateRange = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isTimeInputFocused = _useState4[0],
    setTimeInputFocused = _useState4[1];
  var selectedRange = getDateStats$1(startDate, endDate);
  useEffect(function () {
    setDateRange(selectedRange);
  }, [selectedRange]);
  var onDropdownChange = function onDropdownChange(value) {
    var today = dayjs_min().startOf("day");
    setDateRange(value);
    switch (value) {
      case "Today":
        onChange(today, today.endOf("day"));
        break;
      case "Yesterday":
        onChange(today.subtract(1, "d").startOf("day"), today.subtract(1, "d").endOf("day"));
        break;
      case "Last 7 days":
        onChange(today.subtract(6, "d").startOf("day"), today.endOf("day"));
        break;
      case "Last 30 days":
        onChange(today.subtract(29, "d").startOf("day"), today.endOf("day"));
        break;
    }
  };
  var isEndTimeGreater = function isEndTimeGreater(isCompare) {
    if (isCompare) {
      return comparisonStartDate.isSame(comparisonEndDate, "d") && dayjs_min(comparisonEndTime).isBefore(comparisonStartTime);
    }
    return dayjs_min(startDate).isSame(endDate, "d") && dayjs_min(endTime).isBefore(startTime);
  };
  return /*#__PURE__*/React.createElement(Wrapper$1, {
    ref: wrapperRef,
    width: withTime ? 260 : 130,
    className: "".concat(prefixClassName, "-date-ranges")
  }, /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    padding: 0,
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "h4.semi-bold"
  }, "Date Range"), /*#__PURE__*/React.createElement(Dropdown, {
    placeholder: "Date Range",
    options: ["Custom", "Today", "Yesterday", "Last 7 days", "Last 30 days"],
    value: dateRange,
    size: "small",
    themed: true,
    attachTo: wrapperRef,
    onChange: onDropdownChange
  })), /*#__PURE__*/React.createElement(Box, {
    flexDirection: "column",
    padding: "8px 0px",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "h4.semi-bold"
  }, "From"), /*#__PURE__*/React.createElement(DateRanges, {
    dateKey: "startDate",
    timeKey: "startTime",
    dateValue: startDate,
    onFocus: onFocus,
    selectingKey: selectingKey,
    withTime: withTime,
    setTime: setTime,
    timeValue: startTime,
    isTimeInputFocused: isTimeInputFocused,
    setTimeInputFocused: setTimeInputFocused
  })), /*#__PURE__*/React.createElement(Box, {
    flexDirection: "column",
    padding: "8px 0px",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "h4.semi-bold"
  }, "To"), /*#__PURE__*/React.createElement(DateRanges, {
    dateKey: "endDate",
    timeKey: "endTime",
    dateValue: endDate,
    onFocus: onFocus,
    selectingKey: selectingKey,
    withTime: withTime,
    setTime: setTime,
    timeValue: endTime,
    isTimeInputFocused: isTimeInputFocused,
    setTimeInputFocused: setTimeInputFocused
  })), isEndTimeGreater(false) && /*#__PURE__*/React.createElement(ErrorComponent, null), withComparison && /*#__PURE__*/React.createElement(Box, {
    borderWidth: 0,
    borderTopWidth: 1,
    borderColor: "grey.haptik",
    display: "block",
    padding: "16px 12px",
    margin: "20px -12px 0px -12px"
  }, /*#__PURE__*/React.createElement(Toggle, {
    label: "Compare",
    value: toggled,
    onChange: onToggle,
    themed: true
  }), toggled && /*#__PURE__*/React.createElement(Box, {
    padding: 0,
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Box, {
    flexDirection: "column",
    padding: "8px 0px",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "h4.semi-bold"
  }, "From"), /*#__PURE__*/React.createElement(DateRanges, {
    dateKey: "comparisonStartDate",
    timeKey: "comparisonStartTime",
    dateValue: comparisonStartDate,
    onFocus: onFocus,
    selectingKey: selectingKey,
    withTime: withTime,
    setTime: setTime,
    timeValue: comparisonStartTime,
    isTimeInputFocused: isTimeInputFocused,
    setTimeInputFocused: setTimeInputFocused
  })), /*#__PURE__*/React.createElement(Box, {
    flexDirection: "column",
    padding: "8px 0px",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "h4.semi-bold"
  }, "To"), /*#__PURE__*/React.createElement(DateRanges, {
    dateKey: "comparisonEndDate",
    timeKey: "comparisonEndTime",
    dateValue: comparisonEndDate,
    onFocus: onFocus,
    selectingKey: selectingKey,
    withTime: withTime,
    setTime: setTime,
    timeValue: comparisonEndTime,
    isTimeInputFocused: isTimeInputFocused,
    setTimeInputFocused: setTimeInputFocused
  })), isEndTimeGreater(true) && /*#__PURE__*/React.createElement(ErrorComponent, null))));
};
var DateRanges = function DateRanges(_ref2) {
  var dateKey = _ref2.dateKey,
    timeKey = _ref2.timeKey,
    dateValue = _ref2.dateValue,
    _onFocus = _ref2.onFocus,
    selectingKey = _ref2.selectingKey,
    withTime = _ref2.withTime,
    setTime = _ref2.setTime,
    timeValue = _ref2.timeValue,
    isTimeInputFocused = _ref2.isTimeInputFocused,
    setTimeInputFocused = _ref2.setTimeInputFocused;
  var formattedDate = dayjs_min.isDayjs(dateValue) ? dayjs_min(dateValue).format("DD/MM/YYYY") : "";
  var onTimeChange = function onTimeChange(value) {
    setTime(timeKey, value);
  };
  var timeInputActiveStatus = function timeInputActiveStatus(val) {
    setTimeInputFocused(val);
  };
  return /*#__PURE__*/React.createElement(Box, {
    padding: 0,
    pt: 4,
    width: "100%"
  }, /*#__PURE__*/React.createElement(Box, {
    padding: 0,
    pr: 4,
    width: withTime ? "54%" : "100%"
  }, /*#__PURE__*/React.createElement(Text$1, {
    themed: true,
    placeholder: "Selecting",
    prefixIcon: /*#__PURE__*/React.createElement(CalendarIcon$1, {
      borderWidth: 0
    }),
    value: formattedDate,
    onFocus: function onFocus() {
      return _onFocus(dateKey);
    },
    manuallyFocused: selectingKey === dateKey && !isTimeInputFocused,
    controlledInput: true
  })), withTime && /*#__PURE__*/React.createElement(Box, {
    padding: 0,
    width: "46%"
  }, /*#__PURE__*/React.createElement(TimeInputWrapper, {
    themed: true,
    placeholder: "time",
    prefixIcon: /*#__PURE__*/React.createElement(TimeIconV2$1, {
      borderWidth: 0
    }),
    onChange: onTimeChange,
    value: timeValue,
    hideTooltipArrow: true,
    toggleStatus: timeInputActiveStatus,
    controlledInput: true
  })));
};
InputThemed.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "InputThemed"
};

var RangePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(RangePicker, _React$Component);
  var _super = _createSuper(RangePicker);
  function RangePicker(props) {
    var _this;
    _classCallCheck(this, RangePicker);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "isEndTimeValid", function (isCompare) {
      var _this$state = _this.state,
        startDate = _this$state.startDate,
        endDate = _this$state.endDate,
        comparisonStartDate = _this$state.comparisonStartDate,
        comparisonEndDate = _this$state.comparisonEndDate,
        startTime = _this$state.startTime,
        endTime = _this$state.endTime,
        comparisonStartTime = _this$state.comparisonStartTime,
        comparisonEndTime = _this$state.comparisonEndTime;
      if (isCompare) {
        return comparisonStartDate ? comparisonStartDate.isSame(comparisonEndDate, "d") && dayjs_min(comparisonEndTime).isBefore(dayjs_min(comparisonStartTime)) : false;
      }
      return dayjs_min(startDate).isSame(endDate || startDate, "d") && dayjs_min(endTime).isBefore(dayjs_min(startTime));
    });
    _defineProperty(_assertThisInitialized(_this), "getValue", function () {
      var _this$state2 = _this.state,
        startDate = _this$state2.startDate,
        endDate = _this$state2.endDate,
        comparisonStartDate = _this$state2.comparisonStartDate,
        comparisonEndDate = _this$state2.comparisonEndDate,
        startTime = _this$state2.startTime,
        endTime = _this$state2.endTime,
        comparisonStartTime = _this$state2.comparisonStartTime,
        comparisonEndTime = _this$state2.comparisonEndTime;
      var format = "DD MMM, YYYY";
      var timeFormat = "hh:mm A";
      var defaultStartTime = dayjs_min().startOf("day");
      var defaultEndTime = dayjs_min().endOf("day");
      var updatedStartTime = startTime;
      var updatedEndTime = endTime;
      var updatedComparisonEndTime = comparisonEndTime;
      var updatedComparisonStartTime = comparisonStartTime;

      // if end time is less than start time then defaulting
      // start time to 12 am and end time 11:59 PM
      if (_this.isEndTimeValid(false)) {
        updatedStartTime = defaultStartTime;
        updatedEndTime = defaultEndTime;
      }

      // for compare state
      // if end time is less than start time then defaulting
      // start time to 12 am and end time 11:59 PM
      if (_this.isEndTimeValid(true)) {
        updatedComparisonEndTime = defaultEndTime;
        updatedComparisonStartTime = defaultStartTime;
      }
      var startDateWithTime = new Date("".concat(startDate.format(format), " ").concat(dayjs_min(updatedStartTime).format(timeFormat)));
      var endDateWithTime = new Date("".concat((endDate || startDate).format(format), " ").concat(dayjs_min(updatedEndTime).format(timeFormat)));
      var compareStartDatewithTime = comparisonStartDate ? new Date("".concat(comparisonStartDate.format(format), " ").concat(dayjs_min(updatedComparisonStartTime).format(timeFormat))) : null;
      var compareEndDatewithTime = comparisonEndDate ? new Date("".concat(comparisonEndDate.format(format), " ").concat(dayjs_min(updatedComparisonEndTime).format(timeFormat))) : null;
      return {
        startDate: startDate ? startDate.startOf("day").toDate() : startDate,
        endDate: endDate ? endDate.endOf("day").toDate() : startDate,
        comparisonStartDate: comparisonStartDate ? comparisonStartDate.startOf("day").toDate() : null,
        comparisonEndDate: comparisonEndDate ? comparisonEndDate.endOf("day").toDate() : null,
        startTime: updatedStartTime,
        endTime: updatedEndTime,
        comparisonStartTime: updatedComparisonStartTime,
        comparisonEndTime: updatedComparisonEndTime,
        startDateWithTime: startDateWithTime,
        endDateWithTime: endDateWithTime,
        compareStartDatewithTime: compareStartDatewithTime,
        compareEndDatewithTime: compareEndDatewithTime
      };
    });
    /**
     * On clicking the cell we want to start/end the range selection depending on the
     * current state
     * So if the current selection is startDate, we start endDate selection and so on
     * We use this.state.selectingKey to track this
     */
    _defineProperty(_assertThisInitialized(_this), "_handleCellClick", function (day) {
      var _this$state3 = _this.state,
        selectingKey = _this$state3.selectingKey,
        compare = _this$state3.compare,
        startDate = _this$state3.startDate,
        comparisonStartDate = _this$state3.comparisonStartDate;
      var _this$props = _this.props,
        comparisonMaxDate = _this$props.comparisonMaxDate,
        themed = _this$props.themed;
      if (selectingKey === "startDate") {
        _this.setState({
          selectingKey: "endDate",
          endDate: null
        });
      } else if (compare && selectingKey === "comparisonStartDate") {
        var _this$state4 = _this.state,
          _startDate = _this$state4.startDate,
          endDate = _this$state4.endDate;
        var numDays = endDate && endDate.diff(_startDate, "d");
        var compMaxDate = comparisonMaxDate && dayjs_min(comparisonMaxDate).isBefore(day.add(numDays, "d")) ? dayjs_min(comparisonMaxDate) : day.add(numDays, "d");
        _this.setState({
          selectingKey: "comparisonStartDate",
          comparisonEndDate: compMaxDate
        });
      } else if (selectingKey === "comparisonEndDate" && themed) {
        _this.setState({
          selectingKey: "comparisonStartDate"
        });
      } else {
        _this.setState({
          selectingKey: "startDate"
        });
      }

      // not allowing user to select end dates less than start dates
      if (selectingKey === "endDate" && dayjs_min(day).isBefore(startDate) || selectingKey === "comparisonEndDate" && dayjs_min(day).isBefore(comparisonStartDate)) {
        _this.setState({
          selectingKey: selectingKey
        });
      } else _this.setState(_defineProperty({}, selectingKey, day));
    });
    /**
     * Sets the startDate and endDate
     * Also resets the month in focus to default
     */
    _defineProperty(_assertThisInitialized(_this), "_setDates", function (startDate, endDate) {
      _this.setState({
        startDate: startDate,
        endDate: endDate,
        selectingKey: "startDate"
      });
    });
    _defineProperty(_assertThisInitialized(_this), "setTime", function (timekey, value) {
      _this.setState(_defineProperty({}, timekey, value));
    });
    _defineProperty(_assertThisInitialized(_this), "_setComparisonDates", function (comparisonStartDate, comparisonEndDate) {
      var selectingKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.state.selectingKey;
      _this.setState({
        comparisonStartDate: comparisonStartDate,
        comparisonEndDate: comparisonEndDate,
        selectingKey: selectingKey
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_onToggle", function (newCompare) {
      var _this$state5 = _this.state,
        startDate = _this$state5.startDate,
        endDate = _this$state5.endDate,
        startTime = _this$state5.startTime,
        endTime = _this$state5.endTime;
      var comparisonMaxDate = _this.props.comparisonMaxDate;
      var numDays = endDate && endDate.diff(startDate, "d") + 1;
      var comparisonStart = null;
      var comparisonEnd = null;
      _this.setState({
        compare: newCompare,
        selectingKey: newCompare ? "comparisonStartDate" : "startDate"
      });
      if (newCompare && startDate && endDate) {
        comparisonStart = startDate.subtract(numDays, "d");

        // setting maximum selectable compare date as comparisonEndDate
        comparisonEnd = comparisonMaxDate && comparisonMaxDate < startDate.subtract(1, "d") ? comparisonMaxDate : startDate.subtract(1, "d");
      }
      _this.setState({
        comparisonStartDate: comparisonStart,
        comparisonEndDate: comparisonEnd,
        comparisonStartTime: startTime,
        comparisonEndTime: endTime
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_getParsedValue", function () {
      var _this$props$value = _this.props.value,
        value = _this$props$value === void 0 ? {} : _this$props$value;
      var startDate = dayjs_min(value.startDate);
      var endDate = dayjs_min(value.endDate);
      var comparisonStartDate = value.comparisonStartDate ? dayjs_min(value.comparisonStartDate) : null;
      var comparisonEndDate = value.comparisonEndDate ? dayjs_min(value.comparisonEndDate) : null;
      return {
        startDate: startDate,
        endDate: endDate,
        comparisonStartDate: comparisonStartDate,
        comparisonEndDate: comparisonEndDate,
        startTime: value.startTime,
        endTime: value.endTime,
        comparisonStartTime: value.comparisonStartTime,
        comparisonEndTime: value.comparisonEndTime
      };
    });
    var _value = _objectSpread2({}, _this._getParsedValue(props.value));
    _value.compare = _value.comparisonStartDate && _value.comparisonEndDate;
    _this.setState(_value);
    _this.state = {
      startDate: _value.startDate,
      endDate: _value.endDate,
      compare: _value.compare,
      comparisonStartDate: _value.comparisonStartDate,
      comparisonEndDate: _value.comparisonEndDate,
      startTime: _value.startTime,
      endTime: _value.endTime,
      comparisonEndTime: _value.comparisonEndTime,
      comparisonStartTime: _value.comparisonStartTime,
      selectingKey: "startDate"
    };
    dayjs_min.extend(customParseFormat);
    return _this;
  }
  _createClass(RangePicker, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state6 = this.state,
        startDate = _this$state6.startDate,
        endDate = _this$state6.endDate,
        comparisonStartDate = _this$state6.comparisonStartDate,
        comparisonEndDate = _this$state6.comparisonEndDate,
        compare = _this$state6.compare,
        selectingKey = _this$state6.selectingKey,
        startTime = _this$state6.startTime,
        endTime = _this$state6.endTime,
        comparisonEndTime = _this$state6.comparisonEndTime,
        comparisonStartTime = _this$state6.comparisonStartTime;
      var _this$props2 = this.props,
        prefixClassName = _this$props2.prefixClassName,
        numMonths = _this$props2.numMonths,
        maxDate = _this$props2.maxDate,
        minDate = _this$props2.minDate,
        comparisonMaxDate = _this$props2.comparisonMaxDate,
        withComparison = _this$props2.withComparison,
        themed = _this$props2.themed,
        InfoCard = _this$props2.InfoCard,
        withThemedTime = _this$props2.withThemedTime;
      var value = [{
        from: startDate,
        to: endDate,
        color: themed ? "blue.pastel" : "#1b9cfc",
        startEndColor: "blue.haptik"
      }];
      if (withComparison) {
        value = value.concat({
          from: comparisonStartDate,
          to: comparisonEndDate,
          color: themed ? "teal.pastel" : "#f1c40f",
          startEndColor: "teal.haptik"
        });
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$3$1.rangePicker, " ").concat(prefixClassName)
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$3$1.rangePickerCalendarColumn, " ").concat(prefixClassName, "-column")
      }, /*#__PURE__*/React.createElement(Calendar, {
        value: value,
        startDate: startDate,
        endDate: endDate,
        onChange: this._handleCellClick,
        numMonths: numMonths,
        maxDate: maxDate,
        minDate: minDate,
        toggled: compare,
        comparisonMaxDate: comparisonMaxDate,
        prefixClassName: "".concat(prefixClassName, "-calendar"),
        themed: themed,
        InfoCard: InfoCard,
        selectedDateInput: selectingKey,
        comparisonStartDate: comparisonStartDate
      })), themed ? /*#__PURE__*/React.createElement(InputThemed, {
        selectingKey: selectingKey,
        onChange: this._setDates,
        onFocus: function onFocus(key) {
          _this2.setState({
            selectingKey: key
          });
        },
        startDate: startDate,
        endDate: endDate,
        comparisonStartDate: comparisonStartDate,
        comparisonEndDate: comparisonEndDate,
        toggled: compare,
        onToggle: this._onToggle,
        withComparison: withComparison,
        withTime: withThemedTime,
        setTime: this.setTime,
        startTime: startTime,
        endTime: endTime,
        comparisonEndTime: comparisonEndTime,
        comparisonStartTime: comparisonStartTime,
        prefixClassName: prefixClassName
      }) : /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$3$1.rangePickerCalendarColumn, " ").concat(prefixClassName, "-column")
      }, /*#__PURE__*/React.createElement(Inputs, {
        selectingKey: selectingKey,
        startDate: startDate,
        endDate: endDate,
        onChange: this._setDates,
        prefixClassName: "".concat(prefixClassName, "-column-inputs"),
        onFocus: function onFocus(key) {
          _this2.setState({
            selectingKey: key
          });
        }
      }), withComparison ? /*#__PURE__*/React.createElement(Comparison, {
        selectingKey: selectingKey,
        startDate: startDate,
        endDate: endDate,
        comparisonStartDate: comparisonStartDate,
        comparisonEndDate: comparisonEndDate,
        toggled: compare,
        onChange: this._setComparisonDates,
        prefixClassName: "".concat(prefixClassName, "-column-comparison"),
        onToggle: this._onToggle,
        onFocus: function onFocus(key) {
          _this2.setState({
            selectingKey: key
          });
        }
      }) : null));
    }
  }]);
  return RangePicker;
}(React.Component);
RangePicker.propTypes = {
  withComparison: PropTypes.bool,
  prefixClassName: PropTypes.string,
  numMonths: PropTypes.number,
  maxDate: PropTypes.instanceOf(Date),
  minDate: PropTypes.instanceOf(Date),
  comparisonMaxDate: PropTypes.instanceOf(Date),
  value: PropTypes.shape({
    startDate: PropTypes.object,
    endDate: PropTypes.object,
    comparisonStartDate: PropTypes.object,
    comparisonEndDate: PropTypes.object,
    startTime: PropTypes.object,
    endTime: PropTypes.object,
    comparisonEndTime: PropTypes.object,
    comparisonStartTime: PropTypes.object
  }),
  /** Themed version of Date  */
  themed: PropTypes.bool,
  /** Tooltip react element */
  InfoCard: PropTypes.node,
  /** time input when range picker is render */
  withThemedTime: PropTypes.bool
};
RangePicker.defaultProps = {
  withComparison: false,
  numMonths: 2,
  prefixClassName: "",
  maxDate: null,
  minDate: null,
  comparisonMaxDate: null,
  value: {
    startDate: dayjs_min(),
    endDate: dayjs_min(),
    comparisonStartDate: null,
    comparisonEndDate: null,
    startTime: dayjs_min(),
    endTime: dayjs_min(),
    comparisonEndTime: null,
    comparisonStartTime: null
  },
  themed: false,
  withThemedTime: false
};
RangePicker.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "isEndTimeValid",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "isCompare",
      "type": null
    }],
    "returns": null
  }, {
    "name": "getValue",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_handleCellClick",
    "docblock": "On clicking the cell we want to start/end the range selection depending on the\ncurrent state\nSo if the current selection is startDate, we start endDate selection and so on\nWe use this.state.selectingKey to track this",
    "modifiers": [],
    "params": [{
      "name": "day"
    }],
    "returns": null,
    "description": "On clicking the cell we want to start/end the range selection depending on the\ncurrent state\nSo if the current selection is startDate, we start endDate selection and so on\nWe use this.state.selectingKey to track this"
  }, {
    "name": "_setDates",
    "docblock": "Sets the startDate and endDate\nAlso resets the month in focus to default",
    "modifiers": [],
    "params": [{
      "name": "startDate"
    }, {
      "name": "endDate"
    }],
    "returns": null,
    "description": "Sets the startDate and endDate\nAlso resets the month in focus to default"
  }, {
    "name": "setTime",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "timekey",
      "type": null
    }, {
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_setComparisonDates",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "comparisonStartDate",
      "type": null
    }, {
      "name": "comparisonEndDate",
      "type": null
    }, {
      "name": "selectingKey",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_onToggle",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "newCompare",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_getParsedValue",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "RangePicker",
  "props": {
    "withComparison": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "numMonths": {
      "defaultValue": {
        "value": "2",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "prefixClassName": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "maxDate": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "instanceOf",
        "value": "Date"
      },
      "required": false,
      "description": ""
    },
    "minDate": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "instanceOf",
        "value": "Date"
      },
      "required": false,
      "description": ""
    },
    "comparisonMaxDate": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "instanceOf",
        "value": "Date"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "defaultValue": {
        "value": "{\n  startDate: dayjs(),\n  endDate: dayjs(),\n  comparisonStartDate: null,\n  comparisonEndDate: null,\n  startTime: dayjs(),\n  endTime: dayjs(),\n  comparisonEndTime: null,\n  comparisonStartTime: null,\n}",
        "computed": false
      },
      "type": {
        "name": "shape",
        "value": {
          "startDate": {
            "name": "object",
            "required": false
          },
          "endDate": {
            "name": "object",
            "required": false
          },
          "comparisonStartDate": {
            "name": "object",
            "required": false
          },
          "comparisonEndDate": {
            "name": "object",
            "required": false
          },
          "startTime": {
            "name": "object",
            "required": false
          },
          "endTime": {
            "name": "object",
            "required": false
          },
          "comparisonEndTime": {
            "name": "object",
            "required": false
          },
          "comparisonStartTime": {
            "name": "object",
            "required": false
          }
        }
      },
      "required": false,
      "description": ""
    },
    "themed": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Themed version of Date"
    },
    "withThemedTime": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "time input when range picker is render"
    },
    "InfoCard": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Tooltip react element"
    }
  }
};

var css_248z$4 = ".date-picker-tooltip {\n  max-width: unset !important; }\n\n.SinglePicker_singlePicker__1VSSS {\n  background-color: #fff;\n  border-radius: 8px;\n  min-height: 240px;\n  display: flex;\n  align-items: flex-start;\n  color: #333; }\n\n@keyframes SinglePicker_show-in__1I1aQ {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n";
var styles$4 = {"singlePicker":"SinglePicker_singlePicker__1VSSS","show-in":"SinglePicker_show-in__1I1aQ"};
styleInject(css_248z$4);

var SinglePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(SinglePicker, _React$Component);
  var _super = _createSuper(SinglePicker);
  function SinglePicker() {
    var _this;
    _classCallCheck(this, SinglePicker);
    _this = _super.call(this);
    /**
     * On clicking the cell we want to start/end the range selection depending on the
     * current state
     * So if the current selection is startDate, we start endDate selection and so on
     * We use this.state.selectingKey to track this
     */
    _defineProperty(_assertThisInitialized(_this), "_handleCellClick", function (day) {
      _this.props.onChange(day.toDate());
    });
    _defineProperty(_assertThisInitialized(_this), "_getParsedValue", function () {
      var _this$props$value = _this.props.value,
        value = _this$props$value === void 0 ? {} : _this$props$value;
      return dayjs_min(value);
    });
    dayjs_min.extend(customParseFormat);
    return _this;
  }
  _createClass(SinglePicker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        value = _this$props.value,
        prefixClassName = _this$props.prefixClassName,
        maxDate = _this$props.maxDate,
        minDate = _this$props.minDate,
        themed = _this$props.themed;
      var date = this._getParsedValue(value);
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$4.singlePicker, " ").concat(prefixClassName)
      }, /*#__PURE__*/React.createElement(Calendar, {
        prefixClassName: "".concat(prefixClassName, "-calendar"),
        value: [{
          from: date,
          to: date
        }],
        onChange: this._handleCellClick,
        numMonths: 1,
        maxDate: maxDate,
        minDate: minDate,
        themed: themed
      }));
    }
  }]);
  return SinglePicker;
}(React.Component);
SinglePicker.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.object,
  prefixClassName: PropTypes.string,
  maxDate: PropTypes.string,
  minDate: PropTypes.string,
  themed: PropTypes.bool
};
SinglePicker.defaultProps = {
  onChange: function onChange() {},
  value: dayjs_min(),
  prefixClassName: "",
  maxDate: undefined,
  minDate: undefined,
  themed: false
};
SinglePicker.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "_handleCellClick",
    "docblock": "On clicking the cell we want to start/end the range selection depending on the\ncurrent state\nSo if the current selection is startDate, we start endDate selection and so on\nWe use this.state.selectingKey to track this",
    "modifiers": [],
    "params": [{
      "name": "day"
    }],
    "returns": null,
    "description": "On clicking the cell we want to start/end the range selection depending on the\ncurrent state\nSo if the current selection is startDate, we start endDate selection and so on\nWe use this.state.selectingKey to track this"
  }, {
    "name": "_getParsedValue",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "SinglePicker",
  "props": {
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "defaultValue": {
        "value": "dayjs()",
        "computed": true
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "prefixClassName": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "maxDate": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "minDate": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "themed": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$5 = ".Date_date__2Kopj {\n  position: relative; }\n  .Date_dateTime__2Dt6J > div {\n    border-radius: 0;\n    padding: 12px 14px;\n    padding-right: 16px; }\n  .Date_dateTime__2Dt6J .Date_TimePickerInput__timePickerInput___qghY7__2deNi {\n    flex: 1; }\n\n.Date_dateLabel__vFla2 {\n  display: block;\n  color: #666;\n  font-size: 12px;\n  font-weight: 600;\n  margin-bottom: 6px;\n  margin-left: 2px;\n  transition: 0.2s ease-out; }\n  .Date_dateLabel__vFla2.Date_focused__3UXOx {\n    color: #124fa0; }\n\n.Date_dateInputWrapper__1NjtW {\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  overflow: hidden;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #fff;\n  padding: 4px 8px;\n  box-sizing: border-box;\n  cursor: pointer;\n  outline: none;\n  transition: 0.2s ease-out; }\n  .Date_dateInputWrapper__1NjtW.Date_focused__3UXOx {\n    border-color: #124fa0; }\n  .Date_dateInputWrapper__1NjtW.Date_disabled__2Y2C5 {\n    pointer-events: none;\n    background-color: #eee; }\n\n.Date_dateInput__2XBzx {\n  border: none;\n  outline: none;\n  width: 100%;\n  font-size: 12px;\n  white-space: nowrap; }\n  .Date_dateInput__2XBzx span {\n    opacity: 0.3; }\n\n.Date_dateError__12G1Y .Date_dateLabel__vFla2 {\n  color: #f44336; }\n\n.Date_dateError__12G1Y .Date_dateInputWrapper__1NjtW {\n  border-color: #f44336;\n  background-color: rgba(244, 67, 54, 0.05); }\n\n.Date_dateInputSubtext__wfzLF {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 4px;\n  font-size: 12px;\n  position: absolute;\n  bottom: 0;\n  transform: translate3d(0, 100%, 0);\n  padding-top: 4px; }\n\n.Date_dateInputSubtextError__rrvTj {\n  color: #ff0c0c;\n  opacity: 0.8; }\n\n.Date_datePickrInput__1V1L3 {\n  position: absolute;\n  left: 0;\n  bottom: 0; }\n\n.Date_dateInputZeroState__25bPG {\n  font-family: \"Roboto\";\n  display: block;\n  padding: 16px;\n  font-size: 14px;\n  opacity: 0.4; }\n";
var styles$5 = {"date":"Date_date__2Kopj","dateTime":"Date_dateTime__2Dt6J","TimePickerInput__timePickerInput___qghY7":"Date_TimePickerInput__timePickerInput___qghY7__2deNi","dateLabel":"Date_dateLabel__vFla2","focused":"Date_focused__3UXOx","dateInputWrapper":"Date_dateInputWrapper__1NjtW","disabled":"Date_disabled__2Y2C5","dateInput":"Date_dateInput__2XBzx","dateError":"Date_dateError__12G1Y","dateInputSubtext":"Date_dateInputSubtext__wfzLF","dateInputSubtextError":"Date_dateInputSubtextError__rrvTj","datePickrInput":"Date_datePickrInput__1V1L3","dateInputZeroState":"Date_dateInputZeroState__25bPG"};
styleInject(css_248z$5);

var Date$1 = /*#__PURE__*/function (_React$Component) {
  _inherits(Date, _React$Component);
  var _super = _createSuper(Date);
  function Date() {
    var _this;
    _classCallCheck(this, Date);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "_DOMNode", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "rangeComparisonRef", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "getToolTipPosition", function () {
      var attachTo = _this.props.attachTo;
      if (attachTo && attachTo.current && _this._DOMNode && _this._DOMNode.current) {
        var attachToElementHeight = attachTo.current.getBoundingClientRect().height;
        var _this$_DOMNode$curren = _this._DOMNode.current.getBoundingClientRect(),
          bottom = _this$_DOMNode$curren.bottom;
        if (bottom + 270 > attachToElementHeight) {
          // 270 is height of calendar
          return "TOP";
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_getParsedDate", function () {
      var _this$props = _this.props,
        withRange = _this$props.withRange,
        value = _this$props.value,
        withThemedRangeTime = _this$props.withThemedRangeTime,
        withTime = _this$props.withTime;
      var format = "DD MMM, YYYY";
      var timeFormat = "hh:mm A";
      var actualValue = _this.state.date || value;
      if (withRange) {
        var _this$_getParsedValue = _this._getParsedValueFromObject(actualValue),
          startDate = _this$_getParsedValue.startDate,
          endDate = _this$_getParsedValue.endDate,
          startTime = _this$_getParsedValue.startTime,
          endTime = _this$_getParsedValue.endTime;
        if (!startDate.isValid() || !endDate.isValid()) return "";
        if (withThemedRangeTime) {
          var isInvalidTime = dayjs_min(startDate).isSame(endDate, "d") && dayjs_min(endTime).isBefore(startTime);
          // if end time is less than start time then defaulting
          // start time to 12 am and end time 11:59 PM
          if (isInvalidTime) {
            return "".concat(startDate.format(format), " ").concat(dayjs_min().startOf("day").format(timeFormat), "  - ").concat(endDate.format(format), " ").concat(dayjs_min().endOf("day").format(timeFormat));
          }
          return "".concat(startDate.format(format), " ").concat(startTime.format(timeFormat), "  - ").concat(endDate.format(format), " ").concat(endTime.format(timeFormat));
        }
        return "".concat(startDate.format(format), " - ").concat(endDate.format(format));
      }
      var date = _this._getParsedValueFromDate(actualValue);
      if (!date.isValid()) return "Invalid Date";
      if (withTime) return "".concat(date.format("DD/MM/YYYY hh:mm A"));
      return "".concat(date.format("DD MMMM, YYYY"));
    });
    _defineProperty(_assertThisInitialized(_this), "_getParsedValueFromObject", function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.value;
      var startDate = dayjs_min(value.startDate);
      var endDate = dayjs_min(value.endDate);
      var comparisonStartDate = value.comparisonStartDate ? dayjs_min(value.comparisonStartDate) : null;
      var comparisonEndDate = value.comparisonEndDate ? dayjs_min(value.comparisonEndDate) : null;
      var startTime = dayjs_min(value.startTime);
      var endTime = dayjs_min(value.endTime);
      return {
        startDate: startDate,
        endDate: endDate,
        comparisonStartDate: comparisonStartDate,
        comparisonEndDate: comparisonEndDate,
        startTime: startTime,
        endTime: endTime
      };
    });
    _defineProperty(_assertThisInitialized(_this), "_getParsedValueFromDate", function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.value;
      if (!value) return dayjs_min();
      return dayjs_min(value);
    });
    _defineProperty(_assertThisInitialized(_this), "_handleChange", function (date) {
      var newDate = date.toDate ? date.toDate() : date;
      var _this$props2 = _this.props,
        maxDate = _this$props2.maxDate,
        minDate = _this$props2.minDate,
        withTime = _this$props2.withTime;
      if (maxDate && dayjs_min(newDate).isAfter(maxDate)) return _this.setState({
        date: maxDate
      });
      if (minDate && dayjs_min(newDate).isBefore(minDate)) return _this.setState({
        date: minDate
      });
      if (!withTime) {
        _this.setState({
          active: false,
          focused: false,
          date: newDate
        });
        _this.props.onChange(newDate);
      } else {
        _this.setState({
          date: newDate
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "toggleDate", function () {
      var disabled = _this.props.disabled;
      if (!disabled) _this.setState(function (state) {
        return {
          active: !state.active,
          focused: !state.active
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "closeDate", function () {
      _this.setState({
        active: false,
        focused: false
      });
      if (_this.rangeComparisonRef.current) {
        _this.props.onChange(_this.rangeComparisonRef.current.getValue());
      } else if (_this.state.date) {
        _this.props.onChange(_this.state.date);
      }
    });
    _this.state = {
      active: false,
      focused: false,
      date: undefined
    };
    return _this;
  }
  _createClass(Date, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        className = _this$props3.className,
        error = _this$props3.error,
        disabled = _this$props3.disabled,
        maxDate = _this$props3.maxDate,
        minDate = _this$props3.minDate,
        comparisonMaxDate = _this$props3.comparisonMaxDate,
        comparisonMinDate = _this$props3.comparisonMinDate,
        withRange = _this$props3.withRange,
        withComparison = _this$props3.withComparison,
        value = _this$props3.value,
        prefixClassName = _this$props3.prefixClassName,
        numMonths = _this$props3.numMonths,
        withTime = _this$props3.withTime,
        themed = _this$props3.themed,
        InfoCard = _this$props3.InfoCard,
        withThemedRangeTime = _this$props3.withThemedRangeTime,
        offset = _this$props3.offset,
        position = _this$props3.position;
      var errorClassName = error ? styles$5.dateError : "";
      var disabledClassName = disabled ? styles$5.disabled : "";
      return /*#__PURE__*/React.createElement("div", {
        "data-testid": "date",
        className: "".concat(styles$5.date, " ").concat(errorClassName, " ").concat(disabledClassName, " ").concat(className, " ").concat(prefixClassName)
      }, this.renderLabel(), this.renderInput(), /*#__PURE__*/React.createElement(Tooltip, {
        onClose: this.closeDate,
        attachTo: this._DOMNode,
        active: this.state.active,
        offset: offset,
        className: "date-picker-tooltip",
        position: position || this.getToolTipPosition(),
        prefixClassName: "".concat(prefixClassName, "-tooltip"),
        hideArrow: themed
      }, withRange ? /*#__PURE__*/React.createElement(RangePicker, {
        ref: this.rangeComparisonRef,
        value: value,
        maxDate: maxDate,
        minDate: minDate,
        active: this.state.active,
        comparisonMaxDate: comparisonMaxDate,
        comparisonMinDate: comparisonMinDate,
        withComparison: withComparison,
        prefixClassName: "".concat(prefixClassName, "-picker"),
        numMonths: numMonths,
        themed: themed,
        InfoCard: InfoCard,
        withThemedTime: withThemedRangeTime
      }) : /*#__PURE__*/React.createElement(SinglePicker, {
        value: this.state.date || value,
        onChange: this._handleChange,
        maxDate: maxDate,
        minDate: minDate,
        prefixClassName: "".concat(prefixClassName, "-picker"),
        numMonths: numMonths,
        themed: themed
      }), withTime ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$5.dateTime, " ").concat(prefixClassName, "-time")
      }, /*#__PURE__*/React.createElement(TimePicker, {
        prefixClassName: "".concat(prefixClassName, "-time-picker"),
        value: dayjs_min(this.state.date || value),
        onChange: this._handleChange,
        themed: themed
      })) : null));
    }
  }, {
    key: "renderLabel",
    value: function renderLabel() {
      var _this$props4 = this.props,
        prefixClassName = _this$props4.prefixClassName,
        error = _this$props4.error,
        label = _this$props4.label,
        themed = _this$props4.themed;
      if (!label || themed) return null;
      return /*#__PURE__*/React.createElement(Label, {
        focused: this.state.focused,
        error: error,
        className: "".concat(prefixClassName, "-label")
      }, label);
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this2 = this;
      var _this$state = this.state,
        focused = _this$state.focused,
        active = _this$state.active;
      var _this$props5 = this.props,
        placeholder = _this$props5.placeholder,
        prefixClassName = _this$props5.prefixClassName,
        onFocus = _this$props5.onFocus,
        onBlur = _this$props5.onBlur,
        disabled = _this$props5.disabled,
        themed = _this$props5.themed,
        label = _this$props5.label,
        error = _this$props5.error;
      var parsedValue = this._getParsedDate();
      var onInputFocus = function onInputFocus(e) {
        _this2.toggleDate();
        onFocus(e);
      };
      if (themed) {
        return /*#__PURE__*/React.createElement(Text$1, {
          themed: true,
          className: "".concat(prefixClassName, "-input"),
          innerRef: this._DOMNode,
          onKeyDown: this._handleKeyDown,
          onFocus: onInputFocus,
          onBlur: onBlur,
          manuallyFocused: focused,
          active: active,
          value: parsedValue,
          placeholder: placeholder,
          disabled: disabled,
          postfixIcon: /*#__PURE__*/React.createElement(ArrowDownIcon, {
            size: "extraSmall",
            onMouseDown: this.toggleDate,
            disabled: disabled
          }),
          label: label,
          error: error,
          controlledInput: true
        });
      }
      return /*#__PURE__*/React.createElement(TextInput, {
        className: "".concat(prefixClassName, "-input"),
        innerRef: this._DOMNode,
        onKeyDown: this._handleKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseDown: this.toggleDate,
        focused: focused,
        active: active,
        value: parsedValue,
        placeholder: placeholder,
        editable: false,
        disabled: disabled,
        postfixComponent: /*#__PURE__*/React.createElement(Icon, {
          src: AngleDownIcon
        })
      });
    }
  }]);
  return Date;
}(React.Component);
Date$1.propTypes = {
  /** If you want to attach the input tooltip to your a custom input */
  attachTo: PropTypes.object,
  /** The classname to appended to the outermost element */
  className: PropTypes.string,
  /** If the input is disabled (non-editable) */
  disabled: PropTypes.bool,
  /** If the input has an error. */
  error: PropTypes.bool,
  /** The prefix classname appended to all elements */
  prefixClassName: PropTypes.string,
  /** Label text */
  label: PropTypes.string,
  /** Input tooltip offset ({x: 0, y: 0}) */
  offset: PropTypes.object,
  /** onBlur callback */
  onBlur: PropTypes.func,
  /** onChange callback */
  onChange: PropTypes.func,
  /** onFocus callback */
  onFocus: PropTypes.func,
  /** Input placeholder */
  placeholder: PropTypes.string,
  /** Tooltip position (TOP/BOTTOM) */
  position: PropTypes.string,
  /** The date */
  value: PropTypes.string,
  /** Max selectable date */
  maxDate: PropTypes.instanceOf(Date$1),
  /** Min selectable date */
  minDate: PropTypes.instanceOf(Date$1),
  /** Max selectable comparison date */
  comparisonMaxDate: PropTypes.instanceOf(Date$1),
  /** Min selectable comparison date */
  comparisonMinDate: PropTypes.instanceOf(Date$1),
  /** With range support (From Date -> To Date) */
  withRange: PropTypes.bool,
  /** With Comparison support (comparing 2 ranges) */
  withComparison: PropTypes.bool,
  /** If whether to show the time picker or not */
  withTime: PropTypes.bool,
  /** Number of months to show at a time */
  numMonths: PropTypes.number,
  /** Themed version of Date  */
  themed: PropTypes.bool,
  /** Tooltip react element */
  InfoCard: PropTypes.node,
  /** time input when range picker is render */
  withThemedRangeTime: PropTypes.bool
};
Date$1.defaultProps = {
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  label: "",
  className: "",
  value: "",
  placeholder: "",
  error: false,
  disabled: false,
  offset: null,
  position: null,
  attachTo: null,
  maxDate: null,
  minDate: null,
  comparisonMaxDate: null,
  comparisonMinDate: null,
  numMonths: 1,
  withTime: false,
  themed: false,
  withThemedRangeTime: false
};
Date$1.classNames = {
  $prefix: "Outermost element",
  "$prefix-label": "Label",
  "$prefix-input": "Input",
  "$prefix-tooltip": "Tooltip wrapping the picker",
  "$prefix-picker": "The div wrapping the picker inside the tooltip",
  "$prefix-time": "The div wrapping the time picker inside the tooltip",
  "$prefix-time-picker": "The timepicker inside the tooltip",
  "$prefix-picker-calendar": "Calendar element",
  "$prefix-picker-calendar-arrow-left": "Calendar arrow left",
  "$prefix-picker-calendar-arrow-right": "Calendar arrow right",
  "$prefix-picker-calendar-calendar": "The calendar month",
  "$prefix-picker-calendar-calendar-header": "The calendar header",
  "$prefix-picker-calendar-calendar-header-text": "The calendar header's text (Month)",
  "$prefix-picker-calendar-labels": "The wrapper for labels for the days",
  "$prefix-picker-calendar-label": "The labels for the days (Sun, Mon, Tue, etc.)",
  "$prefix-picker-calendar-calendar-grid": "The main calendar grid div",
  "$prefix-picker-calendar-calendar-grid-row": "Each row of the calendar grid",
  "$prefix-picker-calendar-calendar-grid-row-item": "Each item of the grid (the square)",
  "$prefix-picker-calendar-calendar-grid-row-item-selected": "selected grid row item",
  "$prefix-picker-calendar-grid-row-item-text": "The label for each grid item (the day)",
  "$prefix-picker-column": "The column for a range picker",
  "$prefix-picker-column-inputs": "The inputs wrapper",
  "$prefix-picker-column-comparison": "The comparison wrapper",
  "$prefix-picker-column-inputs-shortcuts": "The button shortcuts wrapper",
  "$prefix-picker-column-inputs-shortcuts-button": "The button shortcut",
  "$prefix-picker-column-inputs-label": "The label class",
  "$prefix-picker-column-inputs-hint": "The hint class",
  "$prefix-picker-column-inputs-input-items": "The items class",
  "$prefix-picker-column-inputs-input-item": "The input element",
  "$prefix-picker-column-comparison-shortcuts": "The button shortcuts wrapper",
  "$prefix-picker-column-comparison-shortcuts-button": "The button shortcut",
  "$prefix-picker-column-comparison-toggle": "Comparison toggle",
  "$prefix-picker-column-comparison-input-items": "Comparison inputs wrapper",
  "$prefix-picker-column-comparison-input-item": "Comparison input"
};
Date$1.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "getToolTipPosition",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "renderLabel",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "renderInput",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_getParsedDate",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_getParsedValueFromObject",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_getParsedValueFromDate",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_handleChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "date",
      "type": null
    }],
    "returns": null
  }, {
    "name": "toggleDate",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "closeDate",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "Date",
  "props": {
    "onFocus": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "onFocus callback"
    },
    "onBlur": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "onBlur callback"
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "onChange callback"
    },
    "label": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Label text"
    },
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The classname to appended to the outermost element"
    },
    "value": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The date"
    },
    "placeholder": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Input placeholder"
    },
    "error": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "If the input has an error."
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "If the input is disabled (non-editable)"
    },
    "offset": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "Input tooltip offset ({x: 0, y: 0})"
    },
    "position": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Tooltip position (TOP/BOTTOM)"
    },
    "attachTo": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "If you want to attach the input tooltip to your a custom input"
    },
    "maxDate": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "instanceOf",
        "value": "Date"
      },
      "required": false,
      "description": "Max selectable date"
    },
    "minDate": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "instanceOf",
        "value": "Date"
      },
      "required": false,
      "description": "Min selectable date"
    },
    "comparisonMaxDate": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "instanceOf",
        "value": "Date"
      },
      "required": false,
      "description": "Max selectable comparison date"
    },
    "comparisonMinDate": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "instanceOf",
        "value": "Date"
      },
      "required": false,
      "description": "Min selectable comparison date"
    },
    "numMonths": {
      "defaultValue": {
        "value": "1",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Number of months to show at a time"
    },
    "withTime": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "If whether to show the time picker or not"
    },
    "themed": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Themed version of Date"
    },
    "withThemedRangeTime": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "time input when range picker is render"
    },
    "prefixClassName": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The prefix classname appended to all elements"
    },
    "withRange": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "With range support (From Date -> To Date)"
    },
    "withComparison": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "With Comparison support (comparing 2 ranges)"
    },
    "InfoCard": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Tooltip react element"
    }
  }
};

export { Date$1 as D };
